<template>
  <div v-show="isdisplay" class="deviceMsg">
    <div v-if="isNoAbilityDevice" class="deviceMsg_noAbility">
      <div class="deviceMsg_noAbility_container">
        <img :src="noConfig">
        <p>{{ $t('adddevice.maintenance') }}</p>
      </div>
    </div>
    <template v-if="showDeviceStatus || calibrateReferAbility || calibrateTempReferAbility">
      <div v-if="!isNoAbilityDevice" class="border_title">
        {{ $t('deviceMsg.devicestatus') }}
      </div>
      <el-descriptions
        v-if="!isNoAbilityDevice"
        class="margin-top"
        :column="2"
        border
      >
        <template v-for="(item, index) in model.StatusInfo">
          <el-descriptions-item
            v-if="item.IsShow && item['StatusType'] !== '0x0215' && item['Value1'] !== '254'"
            :key="index"
            label-style="background:#ebf5ff;color:#303030;text-align:center;width:160px;"
            :label="item.Name"
            content-style="width:300px"
          >
            <div>
              <!-- <template v-if="item['StatusType']=='0x0600'">
                {{ calibrateLUXListen(item['Value1'], item["illumination"], item["IsCorrected"]) }}
              </template>
              <template v-else-if="item['StatusType']=='0x0700'">
                {{ calibrateTempListen(item['Value1'], item["illumination"], item["IsCorrected"]) }}
              </template> -->

              <template v-if="item['StatusType'] == '0x0000'">
                <b :style="item['Value'] != '0x0000' ? 'color:#619DF1;height:20px' : 'color:#F13535'">{{ cardLightInforValue(item) }}</b>
                {{ item.ParaUnit }}
              </template>
              <template v-else-if="item['StatusType'] == '0x140A'">
                <div>
                  <div style="display: flex">
                    <template>
                      <img :src="catchRequireErr(() => require('@static/img/hcl/icon-type-' + item['Value1'] + '.png'))" alt="">
                    </template>
                    &nbsp;&nbsp;
                    <div v-if="item['Value1'] == '3'">
                      {{ $t('hcl.cardLightCCT') }}
                    </div>
                    <div v-else-if="item['Value1'] == '1'">
                      {{ $t('hcl.cardLight') }}
                    </div>
                    <div v-else-if="item['Value1'] == '2'">
                      {{ $t('hcl.cardCCT') }}
                    </div>
                    <div v-else>
                      {{ $t('hcl.cardStop') }}
                    </div>
                  </div>
                </div>
              </template>
              <template v-else>
                {{ cardLightInforValue(item) }}
                <template v-if="item['StatusType'] == '0x0300' || item['StatusType'] == '0x0301' || item['StatusType'] == '0x0302'">
                  %
                </template>
                <template v-else>
                  {{ item.ParaUnit }}
                </template>
              </template>
            </div>
          </el-descriptions-item>
        </template>
        <el-descriptions-item v-if="calibrateReferAbility" label-style="background: #ebf5ff;color:#303030;text-align:center;width:160px;" :label="$t('deviceMsg.calibrateLUX')">
          <b>{{ calibrateIsCorrected == true ? calibrateReferValue : '--' }}</b> LUX
        </el-descriptions-item>
        <el-descriptions-item v-if="calibrateTempReferAbility" label-style="background: #ebf5ff;color:#303030;text-align:center;width:160px;" :label="$t('deviceMsg.calibrateTemp')">
          <b>{{ calibrateTempIsCorrected == true ? calibrateTempReferValue : '--' }}</b> ℃
        </el-descriptions-item>
      </el-descriptions>
    </template>
    <div v-if="isShowDeviceOpration" class="border_title">
      {{ $t('deviceMsg.deviceoperating') }}
    </div>
    <div v-if="isShowDeviceOpration" class="scene_bolder clearfix" style="padding: 0 0 40px 0;">
      <OppleDeviceMsgControl
        v-if="isShowDeviceOpration"
        :model="model"
        :is-shuanglu="isShuanglu"
        :config-ability="configAbility"
        :calibrate-refer-ability="calibrateReferAbility"
        :calibrate-temp-refer-ability="calibrateTempReferAbility"
        :action-set="ActionSet"
        :is-show-child-reset="isShowChildReset"
        @onDeviceControlChange="onDeviceControlChange"
        @pannelControl="val => pannelControl(val)"
        @calibrateShow="val => calibrateShow(val)"
        @triggerCurtainCalibrate="handleTriggerCurtainCalibrate"
      />
      <OppleAuth v-if="isaction" code="ActionDevice">
        <!-- 定制化能力 -->
        <div v-if="isActionDisplayDIY(ActionList, ['0x042F0000', '0x042D0000', '0x04290000', '0x042B0000'])" class="scence_box">
          <!-- 空调 -->
          <div class="airConditioningCss" style="position: relative; display: inline-block; padding: 10px; width: 100%; max-width: 688px; height: 502px; background: rgb(245 248 255 / 0.5); border: 1px solid rgb(220 230 255 / 0.5); border-radius: 8px">
            <div class="0x042F0000Css" style="display: block; height: 100px; line-height: 100px; font-size: 18px">
              <img class="card_img" style="height: 25px; vertical-align: middle; margin-left: 52px" :src="getClassSkuImage(model, 'on')">
              <span style="font-weight: bold; margin-left: 5px">{{ model.ChildId != 65535 ? model.ChildName + '-' : '' }}{{ model.DeviceName }}</span>
              <div
                :style="'position: absolute;right: 52px;top: 36px; background: #3E76F3;border-radius: 50%;width: 48px;height: 48px;line-height: 48px;text-align: center;cursor: pointer;' + (conditionerFindActionKey(ActionList, '0x042F0000', 0) ? 'background: #929EB6;' : '')"
                @click="
                  arrayActionDisplayDIY['0x042F0000']['Values'][0].DefaultValue = arrayActionDisplayDIY['0x042F0000']['Values'][0].DefaultValue == '1' ? '0' : '1'
                  doCallAction(arrayActionDisplayDIY['0x042F0000'])
                "
              >
                <i class="el-icon-switch-button" style="color: white; font-size: 27px; margin-top: 9px; margin-left: 1px" />
              </div>
            </div>
            <div class="0x042D0000Css" style="display: flex; height: max-content" :class="{ eventNone: conditionerFindActionKey(ActionList, '0x042F0000', 0) }">
              <div style="width: 70%" class="fl-center">
                <div class="conditioner_temperature">
                  <div style="display: inline-flex">
                    <div class="fl-center" style="width: 100px">
                      <img
                        class="button"
                        src="../../assets/img/ota/temperature-.png"
                        style="width: 80px; cursor: pointer"
                        @click="
                          conditionerSetTemperature('-', arrayActionDisplayDIY['0x042D0000']['Values'][0])
                          doCallAction(arrayActionDisplayDIY['0x042D0000'])
                        "
                      >
                    </div>
                    <div class="fl-center temperaturePlane" style="position: relative">
                      <el-input-number
                        v-model="arrayActionDisplayDIY['0x042D0000']['Values'][0].DefaultValue"
                        :step="1"
                        :min="arrayActionDisplayDIY['0x042D0000']['Values'][0].Min"
                        :max="arrayActionDisplayDIY['0x042D0000']['Values'][0].Max"
                        style="width: 60%; margin-top: 10px"
                        @change="doCallAction(arrayActionDisplayDIY['0x042D0000'])"
                      />
                      <div style="position: absolute; right: 50px; font-size: 18px; top: 96px; font-weight: bold; color: #909399; line-height: 24px; text-shadow: 0px 9px 7px rgba(37, 62, 119, 0.08)">
                        °C
                      </div>
                    </div>
                    <div class="fl-center" style="width: 100px">
                      <img
                        class="button"
                        src="../../assets/img/ota/temperature+.png"
                        style="width: 80px; cursor: pointer"
                        @click="
                          conditionerSetTemperature('+', arrayActionDisplayDIY['0x042D0000']['Values'][0])
                          doCallAction(arrayActionDisplayDIY['0x042D0000'])
                        "
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="0x042B0000Css" style="width: 30%" :class="{ eventNone: conditionerFindActionKey(ActionList, '0x042F0000', 0) }">
                <div v-if="arrayActionDisplayDIY['0x042B0000'] != null">
                  <!-- <el-radio-group @change="doCallAction.apply(this,doCallparam)" v-model="arrayActionDisplayDIY['0x042B0000']['Values'][0].DefaultValue" size="mini" class="conditioner_wind">
                      <el-radio-button v-for="(smodel, i) in arrayActionDisplayDIY['0x042B0000']['Values'][0].EnumValue" :key="'Temp' + smodel.Value" :label="smodel.Value" border>
                      {{ smodel.Name }}
                      </el-radio-button>
                    </el-radio-group> -->
                  <template v-for="(tem, i) in arrayActionDisplayDIY['0x042B0000']['Values'][0].EnumValue" :index="i">
                    <el-button
                      style="border-radius: 4px; margin: 10px; width: 90px; padding: 5px 10px; height: 34px; box-shadow: 5px 7px 14px 0px rgba(60, 114, 234, 0.2)"
                      size="mini"
                      :class="{ blueButton: tem['Value'] == arrayActionDisplayDIY['0x042B0000']['Values'][0].DefaultValue }"
                      @click="
                        arrayActionDisplayDIY['0x042B0000']['Values'][0].DefaultValue = tem['Value']
                        doCallAction(arrayActionDisplayDIY['0x042B0000'])
                      "
                    >
                      <span style="display: inline-block; width: 50px">{{ tem.Name }}</span>
                      <!-- <template v-if="tem['Value'] == 0">
                          <img src="../../assets/img/ota/windAuto.png" style="vertical-align: middle;"/>
                        </template> -->
                      <template>
                        <template v-if="tem['Value'] == 1">
                          <template v-if="arrayActionDisplayDIY['0x042B0000']['Values'][0].DefaultValue == tem['Value']">
                            <template v-if="conditionerFindActionKey(ActionList, '0x042F0000', 0)">
                              <img src="../../assets/img/ota/windL_open_close.png" style="vertical-align: middle; width: 14px">
                            </template>
                            <template v-else>
                              <img src="../../assets/img/ota/windL_open.png" style="vertical-align: middle; width: 14px">
                            </template>
                          </template>
                          <template v-else>
                            <template v-if="conditionerFindActionKey(ActionList, '0x042F0000', 0)">
                              <img src="../../assets/img/ota/windL_close.png" style="vertical-align: middle; width: 14px">
                            </template>
                            <template v-else>
                              <img src="../../assets/img/ota/windL.png" style="vertical-align: middle; width: 14px">
                            </template>
                          </template>
                        </template>
                        <template v-if="tem['Value'] == 2">
                          <template v-if="arrayActionDisplayDIY['0x042B0000']['Values'][0].DefaultValue == tem['Value']">
                            <template v-if="conditionerFindActionKey(ActionList, '0x042F0000', 0)">
                              <img src="../../assets/img/ota/windM_open_close.png" style="vertical-align: middle; width: 14px">
                            </template>
                            <template v-else>
                              <img src="../../assets/img/ota/windM_open.png" style="vertical-align: middle; width: 14px">
                            </template>
                          </template>
                          <template v-else>
                            <template v-if="conditionerFindActionKey(ActionList, '0x042F0000', 0)">
                              <img src="../../assets/img/ota/windM_close.png" style="vertical-align: middle; width: 14px">
                            </template>
                            <template v-else>
                              <img src="../../assets/img/ota/windM.png" style="vertical-align: middle; width: 14px">
                            </template>
                          </template>
                        </template>
                        <template v-if="tem['Value'] == 3">
                          <template v-if="arrayActionDisplayDIY['0x042B0000']['Values'][0].DefaultValue == tem['Value']">
                            <template v-if="conditionerFindActionKey(ActionList, '0x042F0000', 0)">
                              <img src="../../assets/img/ota/windH_open_close.png" style="vertical-align: middle; width: 14px">
                            </template>
                            <template v-else>
                              <img src="../../assets/img/ota/windH_open.png" style="vertical-align: middle; width: 14px">
                            </template>
                          </template>
                          <template v-else>
                            <template v-if="conditionerFindActionKey(ActionList, '0x042F0000', 0)">
                              <img src="../../assets/img/ota/windH_close.png" style="vertical-align: middle; width: 14px">
                            </template>
                            <template v-else>
                              <img src="../../assets/img/ota/windH.png" style="vertical-align: middle; width: 14px">
                            </template>
                          </template>
                        </template>
                      </template>
                    </el-button>
                  </template>
                </div>
              </div>
            </div>
            <div class="0x04290000Css" style="margin-top: 20px" :class="{ eventNone: conditionerFindActionKey(ActionList, '0x042F0000', 0) }">
              <div v-if="arrayActionDisplayDIY['0x04290000'] != null" class="scence_ctr_div">
                <el-radio-group
                  v-model="arrayActionDisplayDIY['0x04290000']['Values'][0].DefaultValue"
                  size="mini"
                  class="conditioner_wind"
                  style="margin-bottom: 18px"
                  @change="doCallAction(arrayActionDisplayDIY['0x04290000'])"
                >
                  <el-radio
                    v-for="(smodel, i) in arrayActionDisplayDIY['0x04290000']['Values'][0].EnumValue"
                    :key="'Mode' + smodel.Value"
                    :style="arrayActionDisplayDIY['0x04290000']['Values'][0].EnumValue.length <= 4 ? 'margin: auto 26px!important;' : 'margin: auto 13px!important;'"
                    :label="smodel.Value"
                    border
                  >
                    <template v-if="smodel.Value == 0">
                      <template v-if="arrayActionDisplayDIY['0x04290000']['Values'][0].DefaultValue == smodel['Value']">
                        <template v-if="conditionerFindActionKey(ActionList, '0x042F0000', 0)">
                          <img src="../../assets/img/ota/auto-close.png">
                        </template>
                        <template v-else>
                          <img src="../../assets/img/ota/auto-clicked.png">
                        </template>
                      </template>
                      <template v-else>
                        <img src="../../assets/img/ota/auto-def.png">
                      </template>
                    </template>
                    <template v-if="smodel.Value == 1">
                      <template v-if="arrayActionDisplayDIY['0x04290000']['Values'][0].DefaultValue == smodel['Value']">
                        <template v-if="conditionerFindActionKey(ActionList, '0x042F0000', 0)">
                          <img src="../../assets/img/ota/lengfeng-close.png">
                        </template>
                        <template v-else>
                          <img src="../../assets/img/ota/lengfeng-clicked.png">
                        </template>
                      </template>
                      <template v-else>
                        <img src="../../assets/img/ota/lengfeng-def.png">
                      </template>
                    </template>
                    <template v-if="smodel.Value == 2">
                      <template v-if="arrayActionDisplayDIY['0x04290000']['Values'][0].DefaultValue == smodel['Value']">
                        <template v-if="conditionerFindActionKey(ActionList, '0x042F0000', 0)">
                          <img src="../../assets/img/ota/nuanfeng-close.png">
                        </template>
                        <template v-else>
                          <img src="../../assets/img/ota/nuanfeng-clicked.png">
                        </template>
                      </template>
                      <template v-else>
                        <img src="../../assets/img/ota/nuanfeng-def.png">
                      </template>
                    </template>
                    <template v-if="smodel.Value == 3">
                      <template v-if="arrayActionDisplayDIY['0x04290000']['Values'][0].DefaultValue == smodel['Value']">
                        <template v-if="conditionerFindActionKey(ActionList, '0x042F0000', 0)">
                          <img src="../../assets/img/ota/songfeng-close.png">
                        </template>
                        <template v-else>
                          <img src="../../assets/img/ota/songfeng-clicked.png">
                        </template>
                      </template>
                      <template v-else>
                        <img src="../../assets/img/ota/songfeng-def.png">
                      </template>
                    </template>
                    <template v-if="smodel.Value == 4">
                      <template v-if="arrayActionDisplayDIY['0x04290000']['Values'][0].DefaultValue == smodel['Value']">
                        <template v-if="conditionerFindActionKey(ActionList, '0x042F0000', 0)">
                          <img src="../../assets/img/ota/dehumidify-close.png">
                        </template>
                        <template v-else>
                          <img src="../../assets/img/ota/dehumidify-clicked.png">
                        </template>
                      </template>
                      <template v-else>
                        <img src="../../assets/img/ota/dehumidify-def.png">
                      </template>
                    </template>
                    <span>{{ smodel.Name }}</span>
                  </el-radio>
                </el-radio-group>
              </div>
            </div>
          </div>
        </div>
        <!-- <div v-else-if="hasValueType(ActionList,['UIControl_AC_Temperature','UIControl_AC_Mode','UIControl_AC_Speed'])">
            <air-condition
              :action-list="ActionList"
              :model="model"
            />
            <div>
              <template v-for="(mol,tf) in ActionList">
                <template v-for="(tem,tt) in mol.ActionList">
                  <template v-for="(model,mindex) in tem.Values">
                    <div v-if="model.ValueType == 'UIControl_AC_Temperature'">
                      <span>{{ model.Name }}</span>
                    </div>
                    <div v-else-if="model.ValueType == 'UIControl_AC_Mode'">
                      <span>{{ model.Name }}</span>
                      <template v-for="item in model.EnumValue">
                        <div>{{ item.Name }}</div>
                      </template>
                    </div>
                    <div v-else-if="model.ValueType == 'UIControl_AC_Speed'">
                      <span>{{ model.Name }}</span>
                      <template v-for="item in model.EnumValue">
                        <div>{{ item.Name }}</div>
                      </template>
                    </div>
                  </template>
                </template>
              </template>
            </div>
          </div> -->
        <!-- 常规能力 -->
        <div v-else class="scence_box">
          <op-action-container
            v-show="control_space_progress === null "
            :web-container="UIAbiliy?.WebUIConfigV2?.webContainer"
            :action-list="ActionList"
            :show-mode="APP_SHOW_MODE_ENUM.DEVICE"
          >
            <template #action="{ item }">
              <control-item
                :tip-type="1"
                :gp-details="param"
                :action-info="item.actionInfo"
                :show-button="false"
                :is-i-f-t-t="true"
                :is-detail="true"
                :is-need-auto-emit="false"
                :device-model="model"
                :control_space_progress="control_space_progress"
                @do-call-action-middle="
                  (...arg) => {
                    doCallActionClassSku(item.actionInfo, ...arg)
                  }
                "
              />
            </template>
          </op-action-container>
          <ul class="curtainList_row">
            <li v-for="(data, index) in curtainList" :key="index" @click="callCurtainList(data)">
              <div v-for="(item, i) in data.Values" v-show="item.IsShow" :key="i">
                <img v-if="item.EnumValue && item.EnumValue[0] && item.EnumValue[0].IconUrl" :src=" item.EnumValue[0].IconUrl.n">
                <p v-if="item.EnumValue && item.EnumValue[0] && item.EnumValue[0].Name">
                  {{ item.EnumValue[0].Name }}
                </p>
              </div>
            </li>
          </ul>
        </div>

        <template v-if="showTips">
          <div class="hcl-box">
            <div class="hcl-tips">
              <div>
                <i class="el-icon-info" />
                {{ $t('hcl.tips') }}：
              </div>
              <div v-html="$t('hcl.warning2')" />
            </div>
          </div>
        </template>
        <div v-if="control_space_progress !== null" class="device_div_action" style="display: flex;">
          <div style="min-width: 100px;">
            {{ $t('deviceMsg.wait') }}：
          </div>  <OppleProgress :current="control_space_progress" />
        </div>
      </OppleAuth>
      <!--校准弹窗 -->
      <el-dialog
        ref="myCalibrate"
        :visible.sync="calibrateVisible"
        class="timing dataing nodialog"
        :modal-append-to-body="false"
        :append-to-body="true"
        :before-close="handleClose"
      >
        <div
          class="calibrateBox data_box"
          style="height: auto;padding: 10px;background: rgba(247,249,252,1);margin-top: 0px;position: absolute;max-height: 800px;"
        >
          <i
            class="el-icon-close"
            @click="calibrateShow(false)"
          />
          <div
            class="radio-wrap"
            style="position: relative;top: 25px;height:40px;"
          >
            <div class="radio-group">
              <span
                v-if="calibrateReferAbility"
                class="tab"
                :class="calibrate_tab==0 ? 'cur' : ''"
                @click="calibrate_tab = 0"
              >{{ $t('deviceMsg.calibrateLUX') }}</span>
              <span
                v-if="calibrateTempReferAbility"
                class="tab fright textleaveout"
                :class="calibrate_tab==1 ? 'cur' : ''"
                @click="calibrate_tab = 1"
              >{{ $t('deviceMsg.calibrateTemp') }}</span>
            </div>
          </div>
          <div
            v-show="calibrate_tab==0"
            class="dataing_line clearfix marbottom"
            style="margin: 40px 30px 0 30px;width: auto;"
          >
            <ul class="calibrateBoxInner" style="height:350px; overflow-y: scroll;">
              <li class="calibrateHead">
                <div style="width: 100%;">
                  <template v-if="calibrateCurNewList.length>0">
                    {{ $t('deviceMsg.calibrateBoxTip') }}
                  </template>
                  <button
                    v-if="((calibrateResultList.length + calibrateCurNewList.length)<5)"
                    :class="{eventNone:!calibrateVerify(true)}"
                    @click="calibrateAdd()"
                  >
                    {{ $t('deviceMsg.calibrateAddItem') }}
                  </button>
                </div>
              </li>
              <template v-for="(item, index) in calibrateResultList">
                <li
                  :key="item.id"
                  class="calibrateResultHead"
                  style="width: 100%;color: #abaaaa;"
                >
                  <div><span>{{ $t('deviceMsg.calibrateHistoryTip') }}</span><span>({{ timeOffset(item['CreateTime']) }})</span></div>
                </li>
                <li
                  :key="item.id"
                  class="calibrateResultBody"
                >
                  <div style="margin-right: 48px;">
                    <span>{{ item["Value"] }}</span><span>LUX</span>
                  </div>
                  <div><span>{{ item["CorrectionValue"] }}</span><span>LUX</span></div>
                  <div>
                    <button @click="doDeleteDataSampleWait(calibrateResultList, index, item['Id'])">
                      X
                    </button>
                  </div>
                </li>
              </template>
              <template v-for="(item, index) in calibrateCurNewList">
                <li
                  v-if="calibrateCurNewList.length>0"
                  :key="item.id"
                  class="calibrateCurNewHead"
                >
                  <div :style="'margin-right: 36px;'+(item.Readonly?'color: #abaaaa;':'')">
                    {{ $t('deviceMsg.calibrateItemRealityTip') }}:
                  </div>
                  <div :style="item.Readonly?'color: #abaaaa;':''">
                    {{ $t('deviceMsg.calibrateItemInputTip') }}:
                  </div>
                </li>
                <li
                  :key="item.id"
                  class="calibrateCurNewBody"
                >
                  <div style="margin-right: 48px;">
                    <span
                      v-if="item['Value'] != ''"
                      style="color: #abaaaa;"
                    >{{ item["Value"] }}</span><span
                      v-else
                      style="color: #abaaaa;"
                    >{{ calibrateRealtimeValue }}</span><span style="color: #abaaaa;">LUX</span>
                  </div>
                  <div :style="item.Readonly?'background: #eff2f7;':'border: 1px solid #d4d8df;'">
                    <input
                      v-model="item['CorrectionValue']"
                      type="text"
                      :style="'height:35px;'+(item.Readonly?'color: #abaaaa;':'')"
                      :placeholder="$t('deviceMsg.calibrateItemWriteTip')"
                      :disabled="item.Readonly"
                      @input="checkcalibrateValue(index)"
                    >
                    <span :style="item.Readonly?'color: #abaaaa;':''">LUX</span>
                    <!-- <p v-if="recommendY">
                      推荐值: {{ recommendY }}
                    </p> -->
                  </div>
                  <div>
                    <button @click="calibrateRemove(index)">
                      X
                    </button>
                  </div>
                  <p v-if="recommendedY && index === calibrateCurNewList.length - 1" class="recommendedY">
                    {{ $t('deviceMsg.recommendedValue') }}: {{ recommendedY }}
                  </p>  
                </li>
              </template>
              <li
                v-if="(calibrateResultList.length + calibrateCurNewList.length)>=5"
                style="color:red;text-align: left;display: block;"
              >
                {{ $t('deviceMsg.calibrateItemLimitTip').replace('#','5') }}
              </li>
            </ul>
            <CalibrateChat
              :data="calibrateResultList"
              :new-data="calibrateCurNewList"
              :calibrate-realtime-value="calibrateRealtimeValue"
              @recommendedY="handlerRecommendedY"
            />
            <div style="margin: 10px 0;text-align: center;">
              <div style="margin: 0 auto;">
                <button
                  style="background:rgba(0,70,170,1);color:#fff"
                  @click="calibrateSave"
                >
                  {{ $t('deviceMsg.sure') }}
                </button><button @click="calibrateShow(false)">
                  {{ $t('deviceMsg.cancle') }}
                </button>
              </div>
            </div>
          </div>
          <div
            v-show="calibrate_tab==1"
            class="dataing_line clearfix marbottom"
            style="margin: 40px 30px 0 30px;width: auto;"
          >
            <ul class="calibrateBoxInner">
              <li class="calibrateHead">
                <div style="width: 100%;">
                  <template v-if="calibrateTempCurNewList.length>0">
                    {{ $t('deviceMsg.calibrateTempBoxTip') }}
                  </template>
                  <button
                    v-if="((calibrateTempResultList.length + calibrateTempCurNewList.length)<1)"
                    :class="{eventNone:!calibrateTempVerify(true)}"
                    @click="calibrateTempAdd()"
                  >
                    {{ $t('deviceMsg.calibrateAddItem') }}
                  </button>
                </div>
              </li>
              <template v-for="(item, index) in calibrateTempResultList">
                <li
                  :key="item.id"
                  class="calibrateResultHead"
                  style="width: 100%;"
                >
                  <div><span>{{ $t('deviceMsg.calibrateTempHistoryTip') }}</span><span>({{ timeOffset(item['CreateTime']) }})</span></div>
                </li>
                <li
                  :key="item.id"
                  class="calibrateResultBody"
                >
                  <div style="margin-right: 48px;">
                    <span>{{ item["Value"] }}</span><span>℃</span>
                  </div>
                  <div><span>{{ item["CorrectionValue"] }}</span><span>℃</span></div>
                  <div>
                    <button @click="doDeleteTempDataSampleWait(calibrateTempResultList, index, item['Id'])">
                      X
                    </button>
                  </div>
                </li>
              </template>
              <template v-for="(item, index) in calibrateTempCurNewList">
                <li
                  v-if="calibrateTempCurNewList.length>0"
                  :key="item.id"
                  class="calibrateCurNewHead"
                >
                  <div style="margin-right: 36px;">
                    {{ $t('deviceMsg.calibrateTempItemRealityTip') }}:
                  </div>
                  <div>{{ $t('deviceMsg.calibrateTempItemInputTip') }}:</div>
                </li>
                <li
                  :key="item.id"
                  class="calibrateCurNewBody"
                >
                  <div style="margin-right: 48px;">
                    <span v-if="item['Value'] != ''">{{ item["Value"] }}</span><span v-else>{{ calibrateTempRealtimeValue }}</span><span>℃</span>
                  </div>
                  <div style="border: 1px solid rgb(212, 216, 223);">
                    <input
                      v-model="item['CorrectionValue']"
                      type="text"
                      style="height:35px;"
                      :placeholder="$t('deviceMsg.calibrateTempItemWriteTip')"
                      :disabled="item.Readonly"
                      @input="checkcalibrateTempValue(index)"
                    >
                    <span>℃</span>
                  </div>
                  <div />
                </li>
              </template>
              <li
                v-if="(calibrateTempResultList.length + calibrateTempCurNewList.length)>0"
                style="color:red;text-align: right;display: block;"
              >
                {{ $t('deviceMsg.calibrateItemLimitTip').replace('#','1') }}
              </li>
            </ul>
            <div style="margin: 10px 0;text-align: center;">
              <div style="margin: 0 auto;">
                <button
                  style="background:rgba(0,70,170,1);color:#fff"
                  @click="calibrateSave"
                >
                  {{ $t('deviceMsg.sure') }}
                </button><button @click="calibrateShow(false)">
                  {{ $t('deviceMsg.cancle') }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
    <!-- 天幕效果库 test-->
    <TianMuPlanLibrary
      v-if="showTianMu"
      :show-tian-mu="showTianMu"
      :model="model"
      :child-device-list="childDeviceList"
      :PlanId="PlanId"
      :web-container="UIAbiliy?.WebUIConfigV2?.webContainer"
      :action-list="tianmuDynamicActionList"
      :show-mode="APP_SHOW_MODE_ENUM.DEVICE"
      @isTianmuPlanCustom="val => isTianmuPlanCustom = val"
    />
    <OppleAuth
      v-if="model.ChildCategoryType === 1 && $store.state.isProfessional"
      code="ActionDevice"
    >
      <div class="border_title">
        {{ $t('projectmsg.programList') }}
      </div>
      <OppleJiemuDan
        :v-device-id="devicemodel.VDeviceId"
      />
    </OppleAuth>
    
    <!-- 配置参数 -->
    <OppleAuth v-if="isConfiguration && param.length > 0" code="ReadConfigDevice">
      <div class="border_title">
        {{ $t('deviceMsg.parameter') }}
      </div>
      <div class="border_cont">
        <ul class="param_left">
          <li
            v-for="(item, index) in param"
            v-if="item.IsShow"
            :key="'config' + index"
            :class="activeParam == index ? 'cur_param' : ''"
            @click="paramBut(item, index, item.GpNo)"
          >
            {{ item.GpName }}
          </li>
        </ul>
        <template>
          <div class="param_right">
            <div class="activeParam_box">
              <!-- 中继密钥 -->
              <OppleMidSecretConfig
                v-if="isMidSecretConfig(GpDetails)"
                :device="model"
                :gp-list="olddata"
                @onMidSecretSuccess="onMidSecretSuccess"
              />
              <el-scrollbar v-else class="new_scrollbar" style="height: 100%">
                <!-- wifi配置 -->
                <opple-ability-wifi
                  v-if="isWifiConfig(GpDetails) && model"
                  ref="abilityWifi"
                  :item="GpDetails"
                  :device="model"
                  :action-list="ActionList"
                  @refreshWifi="doFindConfigAbility"
                />
                <!-- 中继节点 -->
                <OppleMidSecretLink
                  v-else-if="isMidSecretLink(GpDetails)"
                  :device="model"
                  :gp-list="olddata"
                  :gp-details="GpDetails"
                  :hide-tree="true"
                />
                <opple-ability-form v-else ref="abilityUiFrom">
                  <div>
                    <div v-for="(item, index) in GpDetails.GpDetails" :key="`${activeParam}` + `${index}`" class="param_ip param_position">
                      <template v-if="item.IsShow">
                        <p
                          v-if="item?.UI?.DescDetail && item.isDisplay"
                        >
                          <i class="el-icon-warning" />
                          {{ item?.UI?.DescDetail }}
                        </p>
                        <opple-ability-com
                          v-if="item.isDisplay"
                          :item="item"
                          :gp-details="GpDetails"
                          :ui="GpDetails.UI"
                          :device="model"
                          :action-list="ActionList"
                        />
                        <div v-if="item.ValueType == 'Enum' || item.ValueType == 'UIConfig_Switch'" class="param_ip param_position">
                          <template v-if="item.isDisplay == true">
                            {{ item.Desc }}<span class="device_state" :class="item.ResultCode == 1 ? 'device_Success' : item.ResultCode == 0 ? 'device_ining' : item.ResultCode == 2 ? 'device_Fail' : 'device_Success'">{{ item.ResultCode == 1 ? $t('deviceMsg.configsuccess') : item.ResultCode == 0 ? $t('deviceMsg.configing') : item.ResultCode == 2 ? $t('deviceMsg.configfail') : $t('deviceMsg.configdefault') }}</span>
                            <el-dropdown
                              :disabled="item.Readonly"
                              :class="{ eventNone: item.Readonly }"
                              class="ip_dropdown device_msg_dropdown"
                              @command="handleselect($event, item)"
                            >
                              <el-button class="region-item-style">
                                {{ getDropdownDefaultName(item.EnumValue, item.DefaultValue) }}<i class="el-icon-arrow-down el-icon--right" />
                              </el-button>
                              <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item
                                  v-for="(_model, icount) in item.EnumValue"
                                  :key="'consecond1' + icount"
                                  :disabled="item.Readonly"
                                  :command="_model.Value.toString()"
                                >
                                  {{ _model.Name }}
                                  <template v-if="item.UI?.EnumValueMap">
                                    <br>
                                    <span style="color: #999">{{ item.UI?.EnumValueMap[_model.Value]?.detail }}</span>
                                  </template>
                                </el-dropdown-item>
                              </el-dropdown-menu>
                            </el-dropdown>

                            <em v-if="item.ValueType != 'UIConfig_Switch'">{{ item.ParaUnit }}</em>
                          </template>
                        </div>
                        <div v-else-if="item.ValueType == 'UIControl_Bright'" class="param_ip param_position">
                          <template v-if="item.isDisplay == true">
                            {{ item.Desc }}<span class="device_state" :class="item.ResultCode == 1 ? 'device_Success' : item.ResultCode == 0 ? 'device_ining' : item.ResultCode == 2 ? 'device_Fail' : 'device_Success'">{{ item.ResultCode == 1 ? $t('deviceMsg.configsuccess') : item.ResultCode == 0 ? $t('deviceMsg.configing') : item.ResultCode == 2 ? $t('deviceMsg.configfail') : $t('deviceMsg.configdefault') }}</span> <el-input-number
                              v-model="item.DefaultValue"
                              :disabled="item.Readonly"
                              :min="item.Min"
                              :max="item.Max"
                              class="ip_input input_left"
                              :title="(item.Min != undefined ? item.Min : '') + '-' + (item.Max != undefined ? item.Max : '')"
                              @change="handleInput"
                            /><em>{{ item.ParaUnit }}</em>
                          </template>
                        </div>
                        <div v-else-if="item.ValueType == 'UIControl_ColorTemperature'" class="param_ip param_position">
                          <template v-if="item.isDisplay == true">
                            {{ item.Desc }}<span class="device_state" :class="item.ResultCode == 1 ? 'device_Success' : item.ResultCode == 0 ? 'device_ining' : item.ResultCode == 2 ? 'device_Fail' : 'device_Success'">{{ item.ResultCode == 1 ? $t('deviceMsg.configsuccess') : item.ResultCode == 0 ? $t('deviceMsg.configing') : item.ResultCode == 2 ? $t('deviceMsg.configfail') : $t('deviceMsg.configdefault') }}</span>

                            <template v-if="item.ParaType == 'String'">
                              <el-input
                                v-model="item.DefaultValue"
                                type="text"
                                :disabled="item.Readonly"
                                :maxlength="item.Max"
                                class="ip_input"
                                @change="handleInput"
                              /> <em>{{ item.ParaUnit }}</em>
                            </template>
                            <template v-else>
                              <el-input-number
                                v-model="item.DefaultValue"
                                :disabled="item.Readonly"
                                :min="item.Min"
                                :max="item.Max"
                                class="ip_input input_left"
                                :title="(item.Min != undefined ? item.Min : '') + '-' + (item.Max != undefined ? item.Max : '')"
                                @change="handleInput"
                                @input="hasUIPrecision(item)"
                              /><em>{{ item.ParaUnit }}</em>
                            </template>
                          </template>
                        </div>
                        <div v-else-if="item.ValueType == 'MultipleEnum'" class="param_ip param_position">
                          <template v-if="item.isDisplay == true">
                            <div @click="start">
                              {{ item.Desc }}<span class="device_state" :class="item.ResultCode == 1 ? 'device_Success' : item.ResultCode == 0 ? 'device_ining' : item.ResultCode == 2 ? 'device_Fail' : 'device_Success'">{{ item.ResultCode == 1 ? $t('deviceMsg.configsuccess') : item.ResultCode == 0 ? $t('deviceMsg.configing') : item.ResultCode == 2 ? $t('deviceMsg.configfail') : $t('deviceMsg.configdefault') }}</span>
                              <i class="el-icon-caret-bottom" :class="[rotate ? 'el-icon-caret-top up' : 'el-icon-caret-bottom down']" />
                            </div>
                            <transition name="slide-fade">
                              <div v-show="!rotate">
                                <ul class="deal">
                                  <li v-for="(model, icount) in item.EnumValue" :key="'consecond2' + icount">
                                    <span>{{ model.Name }}</span>

                                    <el-switch
                                      v-model="defaultcheck[icount]"
                                      class="swith"
                                      :disabled="item.Readonly"
                                      :active-value="model.Value"
                                      :inactive-value="-1"
                                      @change="handleChange(item)"
                                    />
                                  </li>
                                </ul>
                              </div>
                            </transition>
                          </template>
                        </div>

                        <div v-else-if="item.ValueType == 'UIControl_MultipleBitEnum_ReverseSwitch'" class="param_ip param_position">
                          <template v-if="item.isDisplay == true">
                            <div @click="start">
                              {{ item.Desc }}<span class="device_state" :class="item.ResultCode == 1 ? 'device_Success' : item.ResultCode == 0 ? 'device_ining' : item.ResultCode == 2 ? 'device_Fail' : 'device_Success'">{{ item.ResultCode == 1 ? $t('deviceMsg.configsuccess') : item.ResultCode == 0 ? $t('deviceMsg.configing') : item.ResultCode == 2 ? $t('deviceMsg.configfail') : $t('deviceMsg.configdefault') }}</span>
                              <i class="el-icon-caret-bottom" :class="[rotate ? 'el-icon-caret-top up' : 'el-icon-caret-bottom down']" />
                            </div>
                            <transition name="slide-fade">
                              <div v-show="!rotate">
                                <ul class="deal">
                                  <li v-for="(model, icount) in item.EnumValue" :key="'zerofire' + icount">
                                    <span>{{ model.Name }}</span>
                                    <el-switch
                                      v-model="defaultcheck[icount]"
                                      class="swith"
                                      :disabled="item.Readonly"
                                      :active-value="0"
                                      :inactive-value="model.Value"
                                      @change="handleChange(item)"
                                    />
                                  </li>
                                </ul>
                              </div>
                            </transition>
                          </template>
                        </div>
                        <template v-if="item.ValueType === 'UIControl_NeighborGroupInput'">
                          <OppleAbilityNeighborGroup ref="abilityNeighborGroup" :item="item" @changeNeighborGroup="changeNeighborGroup" />
                        </template>
                        <div v-if="item.ValueType === 'UIControl_PanelLinkage'">
                          <OppleAbilityPanel ref="abilityPanel" :device="model" :item="item" />
                        </div>
                      </template>
                    </div>
                  </div>
                </opple-ability-form>
              </el-scrollbar>
            </div>
            <OppleAuth v-if="!isMidSecretLink(GpDetails) && !isMidSecretConfig(GpDetails)" code="UpdateConfigDevice">
              <button class="paramSaveBlue paramSave" @click="handleSaveUpgradeType">
                {{ $t('deviceMsg.savesubmit') }}
              </button>
            </OppleAuth>
            <OppleAuth v-if="model.ClassSku === '0x0200031B'" code="UpdateConfigDevice">
              <button class="paramSaveBlue paramSave" @click="handleElfSave">
                {{ $t('deviceMsg.savesubmit') }}
              </button>
            </OppleAuth>
          </div>
        </template>
      </div>
    </OppleAuth>
    <OppleElfNoticeDialog
      v-if="model.ClassSku === '0x0200031B'"
      :visible="isOppleElfNoticeDialogVisible"
      @onOk="handleSave"
      @onClose="hideElfDialog"
    />
    <LightElfDeviceCom v-if="model.ClassSku === '0x0200031B' && $store.state.isNoLimit" ref="LightElfDeviceCom" :device="model" />
    <OppleTriggerIfttt
      v-if="(model.ClassSku === '0x0200031B' || model.ClassSku === '0x0200031E') && $store.state.isNoLimit"
      ref="OppleTriggerIfttt"
      :device="model"
      :GpNo="GpNo || null"
    />

    <!-- inno 按键设置-->
    <DeviceKeySetting
      v-if="showInnoKeySetting() && !showInnoKeySettingV2()"
      :device="model"
      :GpList="param"
      :ActionList="ActionList"
      :web-inno-config="webInnoConfig"
    />
    <!-- inno 按键设置-->
    <DeviceKeySettingV2
      v-if="showInnoKeySettingV2()"
      :device="model"
      :GpList="param"
      :web-inno-config="webInnoConfigV2"
      :relation-limit="relationLimit"
    />
    <!-- inno 按键设置-->
    <DeviceKeySettingInnoPro v-if="showInnoKeySettingPro()" :device="model" />
    <!-- inno旋钮 屏幕设置-->
    <DeviceScreenConfig
      v-if="showInnoScreenSetting() && !showInnoKeySettingV2()"
      :relation-limit="relationLimit"
      :RelationScreen="RelationScreen"
      :GpList="param"
      :device="model"
    />
    <!-- 控制区域（通用，由 webControlAreaConfig 驱动） -->
    <OppleControlArea
      v-if="showControlArea()"
      ref="OppleControlArea"
      :device="model"
      :gp-list="param"
      :config-list="webControlAreaConfig"
      @success="onControlAreaSuccess"
    />
    <!-- ota升级 -->
    <template v-if="isOtaShow && isShowDeviceOta && isOta && !childTiamMuDevice && $store.state.isLimitOTA != true && noOtaList.indexOf(model.ClassSku) === -1">
      <div class="border_title">
        {{ $t('deviceMsg.ota') }}
      </div>
      <div class="scene_bolder clearfix" style="padding: 30px 0">
        <div class="ota_set ota_set_tianmu" style="margin: auto 20px">
          <!-- OTA 升级逻辑已迁移至 OppleOtaCards；otaBoot 由 FindConfigAbility.UIGuide 设置 -->
          <OppleOtaCards
            v-if="!showTianMu && model.VDeviceId"
            ref="OppleOtaCards"
            :device="devicemodel"
            :is-remove-socket="isRemoveSocket"
            :device-model="model"
            :ota-boot="otaBoot"
            :action-list="OtaActionList"
            :device-only="deviceOnly"
            @updateLocalIp="data => (LocalIp = data)"
            @updateLEGattValue="data => (LEGattValue = data)"
            @updateDeviceOnly="deviceOnly = $event"
          />
          <template v-else>
            <OppleOtaCards
              v-for="(item, index) in childDeviceList"
              :key="item.vDeviceId"
              :ref="item.ref"
              :is-remove-socket="isRemoveSocket"
              :device="item"
              :device-model="item"
              :ota-boot="otaBoot"
              :action-list="item.OtaActionList"
              :tian-mu="true"
              :show-key-up="showKeyUp"
              @showUpLevelBtn="showUpLevelBtn"
            />
            <!-- <div v-if="showOneKeyUp" class="oneUpLevel" @click="oneUpLevel">
              {{ $t('tianmu.oneKeyUpLevel') }}
            </div> -->
          </template>
        </div>
      </div>
    </template>
    <!-- 基本信息 -->
    <template>
      <div class="border_title">
        {{ $t('deviceMsg.basicinformation') }}
      </div>

      <el-descriptions class="margin-top" :column="2" border>
        <el-descriptions-item label-style="background: #ebf5ff;color:#303030;text-align:center;width:160px;" :label="$t('deviceMsg.virtualid')">
          {{ model.VDeviceId }}
        </el-descriptions-item>
        <el-descriptions-item label-style="background: #ebf5ff;color:#303030;text-align:center;width:160px;" :label="$t('deviceMsg.cloudid')">
          {{ model.DeviceId }}
        </el-descriptions-item>
        <el-descriptions-item label-style="background: #ebf5ff;color:#303030;text-align:center;width:160px;" :label="$t('deviceMsg.devicename')">
          {{ model.ChildId != 65535 ? model.ChildName + '-' : '' }}{{ model.DeviceName }}
        </el-descriptions-item>
        <el-descriptions-item v-if="model.ParentVDeviceId != model.VDeviceId" label-style="background: #ebf5ff;color:#303030;text-align:center;width:160px;" :label="$t('deviceMsg.parentdevicename')">
          {{ model.ParentDeviceName }}
        </el-descriptions-item>
        <el-descriptions-item label-style="background: #ebf5ff;color:#303030;text-align:center;width:160px;" :label="$t('deviceMsg.devicetype')">
          {{ model.DeviceTypeName }}
        </el-descriptions-item>
        <el-descriptions-item label-style="background: #ebf5ff;color:#303030;text-align:center;width:160px;" :label="$t('deviceMsg.mac')">
          {{ macformate(model.Mac) }}
        </el-descriptions-item>
        <el-descriptions-item label-style="background: #ebf5ff;color:#303030;text-align:center;width:160px;" :label="$t('deviceMsg.deviceclassification')">
          {{ model.ClassSku }}
        </el-descriptions-item>
        <el-descriptions-item label-style="background: #ebf5ff;color:#303030;text-align:center;width:160px;" :label="$t('deviceMsg.deviceclassificationname')">
          {{ model.ClassSkuName }}
        </el-descriptions-item>
        <el-descriptions-item label-style="background: #ebf5ff;color:#303030;text-align:center;width:160px;" :label="$t('deviceMsg.area')">
          {{ model.ParentAreaNames }}
        </el-descriptions-item>
        <el-descriptions-item v-if="LocalIp" label-style="background: #ebf5ff;color:#303030;text-align:center;width:160px;" label="IP">
          {{ LocalIp }}
        </el-descriptions-item>
        <el-descriptions-item v-if="showTianMu" label-style="background: #ebf5ff;color:#303030;text-align:center;width:160px;" :label="$t('tianmu.lockedConfiguration')">
          {{ PlanName }}
          <el-tag
            size="small"
            effect="plain"
            class="custom-tag"
            @click="unbindTianMu"
          >
            {{ $t('base.unbind') }}
          </el-tag>
          <el-tag
            v-if="isTianmuPlanCustom"
            size="small"
            effect="plain"
            class="custom-tag"
            @click="pannelControl(7)"
          >
            {{ $t('base.redraw') }}
          </el-tag>
        </el-descriptions-item>
      </el-descriptions>
    </template>
    <!-- <OppleMidSecret
      :device="model"
      :gp-list="olddata"
    /> -->
    <!-- 关联配置 -->
    <!-- inner不显示关联配置 -->
    <!-- && model.ClassSku !== '0x0010051D' -->
    <OppleDeviceCom
      v-if="!!relationAction && param && param.length > 0"
      :relation-action="relationAction"
      :gp-config="param"
      :device="model"
    />
    <LEGattConfig ref="LEGattConfig" :device="model" @handleSaveConfig="handleSaveConfig" />

    <OppleLightElf
      v-if="model.ClassSku === '0x0200031B'"
      :visible="true"
      :device="model"
      @onConfigurationSuccess="onConfigurationSuccess"
    />
    <!-- 天幕子设备 -->
    <OppleTianMuChildDevice v-if="showTianMu" :device-card-list="childDeviceList" :is-exist-gs-device="isExistGsDevice" />
    <OppleFeiFan v-if="['0x2907000E', '0x2907000A'].includes(model.ClassSku)" :device="model" />
  </div>
</template>

<script>
import OppleJiemuDan from '@/components/OppleJiemuDan/index.vue';
import OppleProgress from '@/components/OppleProgress';
import actionAirCondition from '@/components/common/actionAirCondition.vue'
// import {parseVersionName} from '@/utils/parseVersionName.js'
import {
  // BatchSearchFirmwareVersion,
  // GetFirmwareVersionFromDevice,
  FindActionAbilityWithStatus,
  FindConfigAbility,
  SetConfigs,
  Restart,
  Reset,
  Delete,
  CallAction,
  // StartOta,
  FindDevice,
  // StopOta,
  SaveOrUpdateDataSample,
  DeleteDataSample,
  GetDataSampleList,
  Finduiability,
  FindDeviceAbilityByVDeviceId,
} from '@/axios/IDevice.js'
import { alerterror, alertsuccess, success, warning ,error } from '@/assets/js/common.js'
// import panelBoot from '@/components/common/panelBoot.vue' // 已迁移至 OppleOtaCards
import colorPicker from '@/components/deviceAction/colorPicker/main.vue'
import colorPickers from '@/components/deviceAction/colorPickers'
import { isMatched, catchRequireErr,getDeviceShowMode } from '@/utils/utils'
import { ProfessionalOnlyMsgType, ProfessionalOnlyGpName } from '@/configs/index';
import OppleAbilityCom from '@/components/OppleAbilityUiCom/index';
import OppleAbilityForm from '@/components/OppleAbilityUiCom/form';
// import OppleMidSecret from '@/components/OppleMidSecret/OppleMidSecret/index.vue';
import OppleDeviceCom from '@/components/OppleDeviceCom/RelateConfig/index.vue';
import LightElfDeviceCom from '@/components/OppleLightElf/LightElfDeviceCom.vue';
import OppleControlArea from '@/components/OppleControlArea/index.vue';
import { clearDeviceTriggerDetailCache } from '@/utils/triggerAbility';
import OppleAbilityWifi from '@/components/OppleAbilityUiCom/OppleAbilityWifi.vue';
import OppleAbilityPanel from '@/components/OppleAbilityUiCom/OppleAbilityPanel.vue';
import OppleLightElf from '@/components/OppleLightElf/index.vue';
import OppleTriggerIfttt from '@/components/OppleTriggerIfttt/index.vue';
import OppleElfNoticeDialog from '@/components/OppleLightElf/OppleElfNoticeDialog.vue';
import { isWifiConfig } from '@/components/OppleAbilityUiCom/utils';
import OppleMidSecretLink, { isMidSecretLink } from '@/components/OppleMidSecret/components/Platform';
import OppleMidSecretConfig, { isMidSecretConfig } from '@/components/OppleMidSecret/components/Secret';
import { postWebIOSocket } from '@assets/socket'
import { ActionVo } from '@utils/actionsHandler';
import sleep from '@utils/sleep'
import LEGattConfig from '@/components/common/LEGattConfig'
// import { OTAUpgradeType } from '@/enums/device'
import OppleAbilityNeighborGroup from '@/components/OppleAbilityUiCom/OppleAbilityNeighborGroup.vue';
import debounce from 'lodash/debounce'
import DeviceKeySetting from './deviceKeySetting.vue'
import DeviceKeySettingV2 from './deviceKeySettingV2.vue'
import DeviceKeySettingInnoPro from './deviceKeySettingInnoPro.vue'
import ModeRadio from '@/components/button/ModeRadio.vue'
import WebUIConfig from '@/utils/WebUIConfig'
import controlItem from '@/components/common/controlItem'
import OpActionContainer from '@/components/common/layer/OpActionContainer.vue'
import { APP_SHOW_MODE_ENUM,UICONTROL_CX_CY_Multiple_CHOOSE_ARRAY,UICONTROL_CX_CY_WithMode_ARRAY } from '@/utils/enums'
import DeviceScreenConfig from './deviceScreenConfig.vue'
import { filterSensorStatus } from '@utils/deviceStatus';
import OppleOtaCards from '@/components/OppleOtaCards'
import OppleTianMuChildDevice from '@/components/OppleDeviceTianMu/TianMuChildDevice.vue'
import TianMuPlanLibrary from '@/components/OppleDeviceTianMu/TianMuPlanLibrary.vue'
import DeviceTianMuMixin from '@/components/Mixin/DeviceTianMuMixin'
import TianMuPlayerMixin from '@/components/Mixin/TianMuPlayerMixin'
import { SYNC_TIANMU_VIDEO_DOWNLOAD_STATUS } from '@/components/OppleDeviceTianMu/tianMuPlayer'
import noConfig from '@/assets/img/noConfig.png'
import OppleDeviceMsgControl from '@/components/OppleDeviceMsgControl';
import { areArraysEqualIgnoreOrder } from '@/utils/utils';
import { findByPlanId } from '@/axios/ITianmu.js'
import TianmuProxy from '@/page/tianmu-design/canvas/CanvasMain/lib/TianmuProxy'
import OppleFeiFan from '@/components/OppleFeiFan';
import CalibrateChat from '@/components/CalibrateChat';
// import webInnoConfig from '@/utils/innoWebConfig'
// import webInnoConfigInnoPro from '@/utils/innoWebConfigInnoPro'

const ChildCategoryTypeEum = {
   gateWay : 1,
   adapter:32
}

export default {
  name: "DeviceMsgDailog",
  components: {
    OppleJiemuDan,
    CalibrateChat,
    OppleProgress,
    OppleFeiFan,
    OppleDeviceMsgControl,
    OppleOtaCards,
    actionAirCondition,
    // panelBoot,
    colorPicker,
    colorPickers,
    OppleAbilityCom,
    OppleAbilityForm,
    OppleDeviceCom,
    OppleMidSecretLink,
    OppleAbilityWifi,
    OppleAbilityPanel,
    OppleMidSecretConfig,
    OppleAbilityNeighborGroup,
    LEGattConfig,
    OppleLightElf,
    OppleTriggerIfttt,
    LightElfDeviceCom,
    OppleControlArea,
    OppleElfNoticeDialog,
    controlItem,
    OpActionContainer,
    DeviceKeySetting,
    ModeRadio,
    DeviceScreenConfig,
    DeviceKeySettingV2,
    DeviceKeySettingInnoPro,
    OppleTianMuChildDevice,
    TianMuPlanLibrary
  },
  mixins: [DeviceTianMuMixin, TianMuPlayerMixin],
  provide() {
    return {
      domId: 'deviceMsg',
      [SYNC_TIANMU_VIDEO_DOWNLOAD_STATUS]: this.syncTianMuVideoDownloadStatus,
    }
  },
  // props: ['devicemodel','isExistGsDevice'],
  props: {
    devicemodel: {
      type: Object,
    },
    isExistGsDevice: {//是否存在格兰斯杯设备
      type: Boolean,
      default: false
    },
    isShowDeviceOpration: {//是否显示设备操作
      type: Boolean,
      default: true
    },
    isShowDeviceOta: {//是否显示设备OTA
      type: Boolean,
      default: true
    },
    // 天幕子设备弹窗
    childTiamMuDevice:{
      type: Boolean,
      default: false
    },
    isRemoveSocket: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      UISet: {},
      calibrateLUXListenTimer: null,
      progressInterval: null,
      control_space_progress: null,
      isTianmuPlanCustom: false,
      recommendedY: null,
      calibrateLUXListenTimer: null,
      isShowChildReset: false,
      configAbility: null,
      noConfig: noConfig,
      isNoAbilityDevice: false,
      isShuanglu: false,
      APP_SHOW_MODE_ENUM,
      // upOTAIndex:-1,
      TT: [],
      model: {}, // 当前设备对象
      // CloudVersion: null, // 云版本号（已迁移至 OppleOtaCards）
      // LocalVersion: null, // 当前版本号（已迁移至 OppleOtaCards）
      LocalIp: null, // 当前版本IP（由 OppleOtaCards 同步，用于基本信息展示）
      // IpFieldCode: 0, // 当前版本IP判断（已迁移至 OppleOtaCards）
      isdisplay: false, // 是否显示
      // levelcode: '', // 升级的版本号（已迁移至 OppleOtaCards）
      currentlevel: '', // 当前版本
      // leveltitle: '', // 升级描述（已迁移至 OppleOtaCards）
      // levelpross: 0, // 升级进度（已迁移至 OppleOtaCards）
      // hight_lever: false, // 控制高级选项是否显示（已迁移至 OppleOtaCards）
      // isstop: true, // 是否停止升级（已迁移至 OppleOtaCards）
      // isloadingota: true, // 是否加载OTA升级（已迁移至 OppleOtaCards）
      activeClass: -1, // 选中表示
      showAll: false, // 展示更多
      activeParam: 0, // 左边选项卡切换索引
      isaction: false, // 是否显示控制面板
      isConfiguration: false, // 是否显示配置参数面板
      isOta: true, // 是否显示ota升级
      isOtaShow: true, // 该设备是否不能ota升级
      // blue_set1: false, // 移动按钮显示隐藏
      // blue_set2: false, // 替换按钮显示隐藏
      // blue_set3: false, // 删除按钮显示隐藏
      // blue_set4: false, // 恢复出厂设置按钮显示隐藏
      // blue_set5: false, // 重启按钮显示隐藏
      // blue_set6: false, // 校准按钮显示隐藏
      rotate: false,
      open: true, // 未使用
      // color: '#c3d1e5', // ota升级进度条颜色（已迁移至 OppleOtaCards）
      sliderWarm: 10, // 未使用
      sliderLight: 20, // 未使用
      // otaValue: '7.12.0.71181', // 历史版本选中的值（已迁移至 OppleOtaCards）
      // otas: [
      //   {
      //     value: this.$t('deviceMsg.option1'),
      //     label: '7.12.0.71181'
      //   },
      //   {
      //     value: this.$t('deviceMsg.option2'),
      //     label: '7.12.0.71182'
      //   }
      // ], // 历史版本
      cardDevice: [
        { src: 'icon-3', text: this.$t('deviceMsg.move') },
        { src: 'icon-14', text: this.$t('deviceMsg.replace') },
        { src: 'icon--1', text: this.$t('deviceMsg.delete') },
        { src: 'icon--2', text: this.$t('deviceMsg.factorysetting') },
        { src: 'icon-23', text: this.$t('deviceMsg.restart') }
      ], // 未使用
      param: [], // 配置参数
      GpNo: '', // 提交的GpNo
      ActionList: [], // 操作list
      GpDetails: [], // 点击左边节点下面的根节点 配置参数
      defaultcheck: [], // 开关选中的元素
      defaultKeyid: [], // 开关选中的Keyid
      scenceValue: '',
      changeNum: 0,
      olddata: [], // 原始数据
      // infor_upgrade: this.$t('deviceMsg.upgrade'), // ota升级的描述（已迁移至 OppleOtaCards）
      // infor_issued: this.$t('deviceMsg.issued'),
      // infor_initiatefail: this.$t('deviceMsg.initiatefail'),
      // infor_ingfail: this.$t('deviceMsg.ingfail'),
      // infor_stopsuccess: this.$t('deviceMsg.stopsuccess'),
      // infor_stopfail: this.$t('deviceMsg.stopfail'),
      // infor_waitForupgrade: this.$t('deviceMsg.waitForupgrade'),
      // infor_Upgradeing: this.$t('deviceMsg.Upgradeing'),
      // infor_UpgradeSuccess: this.$t('deviceMsg.UpgradeSuccess'),
      // infor_UpgradeDuplicate: this.$t('deviceMsg.UpgradeDuplicate'),
      // infor_UpgradeFail: this.$t('deviceMsg.UpgradeFail'),
      // infor_UpgradeConfilct: this.$t('deviceMsg.UpgradeConfilct'),
      // infor_ingbusy: this.$t('deviceMsg.UpgradeBusy'),
      // infor_ingprojectidnull: this.$t('deviceMsg.UpgradeProjectIdNull'),
      // customColor: '', // 进度条颜色
      calibrateReferAbility: false, // 设备是否拥有校准能力
      calibrateVisible: false, // 是否显示校准弹窗
      calibrate_tab: 0, // 0照度 1温度

      isWritecalibrateLUX: false, // 是否可输入校准照度
      calibrateResultList: [], // 已有校准数据
      calibrateCurNewList: [], // 新增校准数据
      calibrateRealtimeValue: '', // 设备-照度实时数据
      calibrateReferValue: '', // 设备-照度参考数据
      calibrateIsCorrected: false, // 设备-照度参考数据-是否已校准

      calibrateTempReferAbility: false, // 设备是否拥有校准能力
      calibrateTempResultList: [], // 已有校准数据
      calibrateTempCurNewList: [], // 新增校准数据
      calibrateTempRealtimeValue: '', // 设备-温度实时数据
      calibrateTempReferValue: '', // 设备-温度参考数据
      calibrateTempIsCorrected: false, // 设备-温度参考数据-是否已校准

      calibrateDeleList: [], // 点确认待删除待
      calibrateTempDeleList: [], // 点确认待删除待
      arrayActionDisplayDIY: {
        '0x042F0000': null,
        '0x042D0000': null,
        '0x04290000': null,
        '0x042B0000': null
      },
      arrayRadioDisplayDIY: {
        '0x040B0000': null
      },
      // firmwareVersion: null, // 固件版本（已迁移至 OppleOtaCards）
      // levelprossOTAVersion: null,
      noRebootList:['0x001F0013'],//没有重启的设备
      // panelBootChecked:false,//ota引导确认（已迁移至 OppleOtaCards）
      otaBoot:false, //ota引导
      noOtaList:[],
      curtainList: [],
      isWifiConfig,
      isMidSecretLink,
      isMidSecretConfig,
      UIAbiliy:null,
      LEGattValue:false, //低功耗设备
      isOppleElfNoticeDialogVisible: false,
      relationAction: null,
      relationLimit: null , //屏幕配置权限
      DefaultRelations:[], // 默认屏幕首屏展示数据
      ScreenSetting: null, //屏幕设置信息
      RelationScreen:null, //关联屏幕
      enOceanDevice:false , //是否是EnOcean设备
      webInnoConfig:null, //webInno配置参数
      webInnoConfigV2:null,//webInnoV2配置参数
      webInnoConfigInnoPro:null,//webInnoPro配置参数
      webControlAreaConfig: [], // 控制区域 UI 配置
      isShowReplace: true, //是否显示替换按钮
      showTips: false, //是否显示提示
      needSecondConfirm: true, //是否需要二次确认
      OtaActionList:[],//ota里判断用的
      deviceOnly:true,//中控屏ota升级
      tianmuDynamicActionList:[],//天幕动态能力(倍速和循环),
      showDeviceStatus: true, //是否显示设备状态
      ActionSet: [],
      UICONTROL_CX_CY_Multiple_CHOOSE_ARRAY, //为了兼容多个版本valueType
      UICONTROL_CX_CY_WithMode_ARRAY, //为了兼容多个版本valueType
    }
  },
  computed: {
    socketmodel() {
      return this.$store.state.socketmodel //需要监听的数据
    },
    // disabledBoot(){
    //   //升级引导otaBoot为true的时候根据引导按钮点击以后才可以升级（已迁移至 OppleOtaCards）
    //   return this.otaBoot? !this.panelBootChecked : false
    // },
    // computedClass(){
    //   let version1 = this.firmwareVersion['VersionList'][0].LocalVersion
    //   let version2 = this.firmwareVersion['VersionList'][0].LatestedVersion
    //   if (this.otaBoot) {
    //     return this.panelBootChecked && version1 !== version2 ? 'newset blue' : 'newset gray';
    //   } else {
    //     return version1 !== version2 ? 'newset blue' : 'newset gray';
    //   }
    // },


  },

  watch: {
    socketmodel (rs) {
      this.functionScoketsync_info_event(rs)
    },
    'model.StatusInfo' (StatusInfo) {
      let showDeviceStatus = false;
      (StatusInfo || []).forEach(item => {
        // debugger
        /* 欧洲隐藏网关的节目单 */
        if(!this.$store.state.programListConfig){
          if(item.StatusType === '0x1A08' || item.StatusType === '0x1A09'){
            item.IsShow = false
          }
        }
        if (item.StatusType === '0x0600') {
          this.calibrateLUXListen(item.Value1, item.illumination, item.IsCorrected)
        }

        if (item.StatusType === '0x0700') {
          this.calibrateTempListen(item.Value1, item.illumination, item.IsCorrected)
        }
        if(item.IsShow && item['StatusType']!=='0x0215' && item['Value1'] !=='254'){
          showDeviceStatus = true
        }
      })
      this.showDeviceStatus = showDeviceStatus
    },

    calibrateVisible(val) {
      if (val === false && this.calibrateLUXListenTimer) clearInterval(this.calibrateLUXListenTimer)
    },


    calibrateReferAbility: {
      immediate: true,
      handler(val) {
        // 如果只有温度校准可用，自动切换到温度校准 tab
        if (!this.calibrateReferAbility && val) {
          this.calibrate_tab = 1
        }
      }
    },
    calibrateTempReferAbility: {
      immediate: true,
      handler(val) {
        // 如果只有照度校准可用，自动切换到照度校准 tab
        if (!this.calibrateTempReferAbility && val) {
          this.calibrate_tab = 0
        }
      }
    },
    'ActionList'(ActionList){
      (ActionList || []).forEach(item=>{
        if (item.ActionList[0]) {
          item.ActionList[0].Values.forEach(item=>{

          /* 非专业模式 / 欧洲隐藏网关的节目单 */
          if(!this.$store.state.programListConfig){
              if(item.Type === '0x1A08' || item.Type === '0x1A09'){
                item.IsShow = false
              }
          }
        })
        }
      })
      console.log('.....ActionList 11',ActionList);
    },
    'param'(data){
      console.log('param 变化');

      (data || []).forEach(item=>{
        // item.IsShow = true
        // 都不展示 就不隐藏
        item.IsShow = !(item.GpDetails || []).every(detail => detail.IsShow === false);

        if(!this.$store.state.programListConfig){
          if(item.GpNo ==='6'|| item.GpName === this.$t('sync.config') && item.GpNo ==='7'){
            item.IsShow = false;
          };
        }
      });

      const arr = (data || []).filter((item) => {
        return item.IsShow;
      });

      // 修改这部分逻辑
      if(arr.length) {
        // 如果有当前选中的GpNo，就保持在当前参数
        if(this.GpNo) {
          const currentItem = arr.find(item => item.GpNo === this.GpNo);
          if(currentItem) {
            const currentIndex = data.findIndex(item => item.GpNo === this.GpNo);
            this.paramBut(currentItem, currentIndex, this.GpNo);
            return;
          }
        };
        // 如果没有当前选中的参数，才默认选择第一个
        const firstShowItemIndex = data.findIndex(item => item === arr[0]);
        this.paramBut(arr[0], firstShowItemIndex, arr[0].GpNo);
      }
    }
  },
  beforeDestroy(){
    if (this.isRemoveSocket === false) return;
    
		postWebIOSocket('sync_info_removeall_event');
  },
  destroyed() { 
    this.progressInterval && clearInterval(this.progressInterval)
    if (this.calibrateLUXListenTimer) clearInterval(this.calibrateLUXListenTimer);
  },
  created () { },
  mounted () {
    this.mountedDo()
  },
  methods: {
    async requestReissue() {
      try {

      } catch (e) {

      }
    },

    catchRequireErr,
    // parseVersionName,
    getDeviceShowMode,

    handlerRecommendedY(num) {
      this.recommendedY = num;
    },

    onDeviceControlChange({ type, payload }) {
      this.$emit(type, payload)
    },
    handleTriggerCurtainCalibrate(action) {
      debugger
      if (!action || !Array.isArray(action.Values)) return
     
      this.doCallAction(action)
    },

    filterSensorStatus(device, currentStatus) {
      return filterSensorStatus(device, currentStatus)
    },
    /**
     * 是否显示inno按键设置
     * 关联配置 ui配置 能力表 都需要有才显示
     */
     showInnoKeySettingV2(){
      return !!this.webInnoConfigV2 && !!this.param && !!this.param.length
    },
    /**
     * 是否显示inno按键设置
     * 关联配置 ui配置 能力表 都需要有才显示
     */
    showInnoKeySetting(){
      return !!this.webInnoConfig && !!this.param && !!this.param.length && !!this.ActionList && !!this.ActionList.length
    },
    showInnoKeySettingPro(){
      return !!this.webInnoConfigInnoPro  &&  this.model && this.model.VDeviceId
    },
    /**
     * 是否显示inno屏幕设置
     * 屏幕设置 关联配置 限制配置 都需要有才显示
     */
    showInnoScreenSetting(){
      return !!this.RelationScreen &&!!this.param &&  this.param.length > 0
    },
    showControlArea() {
      return !!this.webControlAreaConfig?.length && !!this.param?.length
    },
    changeNeighborGroup($event,data){
      console.log($event,data)
    },
    onConfigurationSuccess() {
      clearDeviceTriggerDetailCache(this.model.VDeviceId);
      this.$refs.OppleTriggerIfttt && this.$refs.OppleTriggerIfttt.init();
      this.$refs.LightElfDeviceCom && this.$refs.LightElfDeviceCom.init();
      this.$refs.OppleControlArea && this.$refs.OppleControlArea.init();
    },
    onControlAreaSuccess() {
      this.doFindConfigAbility()
    },

    hasValueType(ActionList,valueTypes){
        return ActionList.some(item =>
          item.ActionList.some(action =>
            action.Values.some(value =>
              valueTypes.includes(value.ValueType)
            )
          )
        )
    },
    hastemSplitLine(tem){
      try {
        return tem.UI.SplitLine
      } catch (error) {
        return false
      }
    },
    isMatched:isMatched,
    colorPickerUpdateValue(e,model,data){
      model.DefaultValue = e
      this.doCallAction(data)
    },
    colorPickerUpdateValueChoose(e,model,data){
      if(e.canChange){
        model.DefaultValue = e.value
        this.doCallAction(data)
      }
    },
    /*
      状态识别（已迁移至 OppleOtaCards.handlePanelBootChecke）
    */
    // handleChecked(e){
    //   this.panelBootChecked = e
    // },
    editAddPoint (param) {
      if (param != null && param != '') {
        let _param = param.toString(16)
        _param = this.stringRepairZero(_param, 6)
        if (this.model.ChildCategoryType == 1) {
          // _param = "0x"+_param;
          _param = _param.replace(/(.{2})/g, '$1.')
          _param = _param.substring(0, _param.length - 1)
          const cur = _param.split('.')
          _param += '             ( '
          for (let i = 0; i < cur.length; i++) {
            if (i == 0) {
              _param += this.$t('deviceMsg.gateWayBoard') + ': 0x' + cur[i]
            } else {
              _param +=
                '，             ' +
                this.$t('deviceMsg.gateWaySubCard') +
                i +
                ': 0x' +
                cur[i]
            }
          }
          _param += ' )'
        } else {
          _param = '0x' + _param
        }
        return _param
      }
      param = param == null ? '' : param

      console.log('param', param);

      return param
    },
    getDropdownDefaultName (item, value) {
      const obj = item.find((param) => {
        return param.Value == value
      })
      if (obj != null) {
        return obj.Name
      } else {
        return '....'
      }
    },
    isActionDisplayDIY (itemArray, msgTypes) {
      let result = false
      let i = 0
      let l = itemArray.length
      let obj
      for (; i < l; i++) {
        obj = itemArray[i]
        obj = obj && obj.ActionList
        if (obj != null && obj instanceof Array) {
          obj = obj.find((param) => {
            return msgTypes.indexOf(param.MsgType) >= 0
          })

          if (obj != null && obj != undefined) {
            this.arrayActionDisplayDIY[obj['MsgType']] = obj
            result = true
          } else {
            result = false
            break
          }
        }
      }
      i = null
      l = null
      obj = null
      return result
    },
    handleClose (e) {
      // var myCalibrate = this.$refs.myCalibrate;
      this.calibrateShow(false)
    },
    /**
     * 校准工具显示
     */
    calibrateShow (param) {
      if (this.calibrateLUXListenTimer) clearInterval(this.calibrateLUXListenTimer);

      if (param == true) {
        this.calibrateDeleList = []
        this.calibrateTempDeleList = []
        if (this.calibrateReferAbility) {
          this.calibrateResultList = []
          this.calibrateCurNewList = []
          // this.calibrateAdd();
          // this.getDataSampleListTimer = setInterval(() => {
          //   this.doGetDataSampleList()
          // }, 2000)
          this.calibrateLUXListenTimer = setInterval(() => {
            this.updateCalibrateLUXListen();
          }, 2000);
          this.doGetDataSampleList()
        }
        if (this.calibrateTempReferAbility) {
          this.calibrateTempResultList = []
          this.calibrateTempCurNewList = []
          // calibrateTempAdd();
          this.doGetDataSampleListTemp()
        }
      }
      this.calibrateVisible = param
      if (param == false) {
        this.blue_set6 = false
        this.doFindDevice(null, true)
      }
    },

    async updateCalibrateLUXListen() {
      const res = await FindDevice({
        vDeviceId: this.devicemodel.VDeviceId,
        channelId: this.devicemodel.ChildId
      });

      const statusInfoStr = res?.Result?.StatusInfo || '{}';
      const statusInfo = JSON.parse(statusInfoStr);
      const zhaodu = statusInfo.find(item => item.StatusType === '0x0600');
      
      this.calibrateRealtimeValue = zhaodu.Value?.OriginValue || '';
    },

    /**
     * 校验输入值是数字
     */
    checkcalibrateValue (index) {
      let n = this.calibrateCurNewList[index].CorrectionValue.replace(/[^\d]/g, '')

      if (Number(n) > 3000) {
        n = '3000'
      }

      this.calibrateCurNewList[index].CorrectionValue = n;

      this.calibrateCurNewList = this.calibrateCurNewList.slice();
    },
    /**
     * 校验输入值是数字
     */
    checkcalibrateTempValue (index) {
      this.calibrateTempCurNewList[index].CorrectionValue =
        this.calibrateTempCurNewList[index].CorrectionValue.replace(
          /[^\d\+\.\-\*\/()]+/g,
          ''
        )
    },
    calibrateVerify (justVerify) {
      if (this.calibrateCurNewList.length > 0) {
        let _item = [...this.calibrateCurNewList].pop()
        if (justVerify == true) {
          if (_item.CorrectionValue == '') {
            return false
          }
          return true
        }
        if (_item.Value == '') {
          _item.Value = this.calibrateRealtimeValue
        }
        if (_item.CorrectionValue == '' || _item.Value == '') {
          return false
        }
        _item.Readonly = true
        _item = null
        // Readonly
        return true
      }
      if (justVerify == true) {
        return true
      }
      return true
    },
    calibrateTempVerify (justVerify) {
      if (this.calibrateTempCurNewList.length > 0) {
        let _item = [...this.calibrateTempCurNewList].pop()
        if (justVerify == true) {
          if (_item.CorrectionValue == '') {
            return false
          }
          return true
        }
        if (_item.Value == '') {
          _item.Value = this.calibrateTempRealtimeValue
        }
        if (_item.CorrectionValue == '' || _item.Value == '') {
          return false
        }
        _item.Readonly = true
        _item = null
        // Readonly
        return true
      }
      if (justVerify == true) {
        return true
      }
      return true
    },
    /**
     * 增加校准数据一对
     */
    calibrateAdd () {
      if (
        this.calibrateResultList.length + this.calibrateCurNewList.length <
        5
      ) {
        if (this.calibrateVerify()) {
          this.calibrateCurNewList.push({
            // "Id": 'null',
            ProjectCode: this.$store.state.projectcode,
            DeviceId: this.devicemodel.DeviceId,
            Value: '',
            CorrectionValue: '',
            StatusType: '0x0600'
          })
        }
      }
    },
    calibrateTempAdd () {
      if (
        this.calibrateTempResultList.length +
        this.calibrateTempCurNewList.length <
        1
      ) {
        if (this.calibrateTempVerify()) {
          this.calibrateTempCurNewList = [
            {
              // "Id": 'null',
              ProjectCode: this.$store.state.projectcode,
              DeviceId: this.devicemodel.DeviceId,
              Value: '',
              CorrectionValue: '',
              StatusType: '0x0700'
            }
          ]
        }
      }
    },
    /**
     * 删除指定校准数据一对
     */
    calibrateRemove (index) {
      if (this.calibrateCurNewList.length > 1) {
        this.calibrateCurNewList.splice(index, 1)
      } else {
        this.calibrateCurNewList = []
        // this.calibrateAdd();
      }
    },
    /**
     * 实际照度值同步 - 用于校准
     */

    calibrateLUXListen (param, illumination, IsCorrected) {
      this.calibrateRealtimeValue = param
      this.calibrateReferValue = illumination
      this.calibrateIsCorrected = IsCorrected
    },
    /**
     * 实际温度度值同步 - 用于校准
     */
    calibrateTempListen (param, illumination, IsCorrected) {
      this.calibrateTempRealtimeValue = param
      this.calibrateTempReferValue = illumination
      this.calibrateTempIsCorrected = IsCorrected
    },
    calibrateSave () {
      if (this.calibrate_tab == 0) {
        if (this.calibrateCurNewList.length > 0) {
          var _calibrateVerify = this.calibrateVerify()
          if (
            _calibrateVerify == true &&
              this.calibrateCurNewList.length == 1 ||
            this.calibrateCurNewList.length > 1
          ) {
            if (this.calibrateDeleList.length > 0) {
              DeleteDataSample(
                { index: null, id: this.calibrateDeleList.join(',') },
                (rs) => {
                  if (rs.StatusCode != this.$store.state.rightStatusCode) {
                    alerterror(this, rs.StatusCode)
                  }
                  if (
                    this.calibrateCurNewList.length > 1 &&
                    _calibrateVerify == false
                  ) {
                    this.calibrateCurNewList.pop()
                  }
                  SaveOrUpdateDataSample(
                    this.calibrateCurNewList,
                    this.functionSaveOrUpdateDataSample
                  )
                }
              )
            } else {
              if (
                this.calibrateCurNewList.length > 1 &&
                _calibrateVerify == false
              ) {
                this.calibrateCurNewList.pop()
              }
              SaveOrUpdateDataSample(
                this.calibrateCurNewList,
                this.functionSaveOrUpdateDataSample
              )
            }
          } else {
            warning(this, this.$t('deviceMsg.calibrateItemWriteTip'))
          }
          _calibrateVerify = null
        } else{
          this.calibrateVisible = false
        }

        if (this.calibrateDeleList.length > 0) {
            DeleteDataSample(
              { index: null, id: this.calibrateDeleList.join(',') },
              this.functionSaveOrUpdateDataSample
            )
          }
      } else if (this.calibrate_tab == 1) {
        if (this.calibrateTempCurNewList.length > 0) {
          var _calibrateVerify = this.calibrateTempVerify()
          if (
            _calibrateVerify == true &&
              this.calibrateTempCurNewList.length == 1 ||
            this.calibrateTempCurNewList.length > 1
          ) {
            if (this.calibrateTempDeleList.length > 0) {
              DeleteDataSample(
                { index: null, id: this.calibrateTempDeleList.join(',') },
                (rs) => {
                  if (rs.StatusCode != this.$store.state.rightStatusCode) {
                    alerterror(this, rs.StatusCode)
                  }
                  if (
                    this.calibrateTempCurNewList.length > 1 &&
                    _calibrateVerify == false
                  ) {
                    this.calibrateTempCurNewList.pop()
                  }
                  SaveOrUpdateDataSample(
                    this.calibrateTempCurNewList,
                    this.functionSaveOrUpdateDataSample
                  )
                }
              )
            } else {
              if (
                this.calibrateTempCurNewList.length > 1 &&
                _calibrateVerify == false
              ) {
                this.calibrateTempCurNewList.pop()
              }
              SaveOrUpdateDataSample(
                this.calibrateTempCurNewList,
                this.functionSaveOrUpdateDataSample
              )
            }
          } else {
            warning(this, this.$t('deviceMsg.calibrateItemWriteTip'))
          }
          _calibrateVerify = null
        } else{
          this.calibrateVisible = false
        }
         if (this.calibrateTempDeleList.length > 0) {
            DeleteDataSample(
              { index: null, id: this.calibrateTempDeleList.join(',') },
              this.functionSaveOrUpdateDataSample
            )
          }
      }
    },
    /**
     * 删除指定设备温度校准数据
     */
    doDeleteTempDataSampleWait (resultList, index, id) {
      resultList.splice(index, 1)
      this.calibrateTempDeleList.push(id)
    },
    doDeleteTempDataSample (index, id, fun) {
      DeleteDataSample({ index, id }, fun)
    },
    functionDoDeleteTempDataSample (rs, params) {
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        if (typeof params.index === 'number') {
          this.calibrateTempResultList.splice(params.index, 1)
        }
        alertsuccess(this, rs.StatusCode)
      } else {
        alerterror(this, rs.StatusCode)
      }
    },
    /**
     * 删除指定设备照度校准数据
     */
    doDeleteDataSampleWait (resultList, index, id) {
      resultList.splice(index, 1)
      this.calibrateDeleList.push(id)
    },
    doDeleteDataSample (index, id) {
      DeleteDataSample(
        { index, id },
        this.functionDoDeleteDataSample
      )
    },
    functionDoDeleteDataSample (rs, params) {
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        if (typeof params.index === 'number') {
          this.calibrateResultList.splice(params.index, 1)
        }
        alertsuccess(this, rs.StatusCode)
      } else {
        alerterror(this, rs.StatusCode)
      }
    },
    /**
     * 获取指定设备照度校准数据列表
     */
    doGetDataSampleListTemp () {
      GetDataSampleList(
        { deviceId: this.devicemodel.DeviceId, statusType: '0x0700' },
        this.functionDoGetDataSampleList
      )
    },
    /**
     * 获取指定设备照度校准数据列表
     */
    async doGetDataSampleList () {
      const param = { deviceId: this.devicemodel.DeviceId, statusType: '0x0600' };
      const res = await GetDataSampleList(
        param
      );

      if (res.StatusCode == this.$store.state.rightStatusCode) {
        if (param.statusType == '0x0600') {
          this.calibrateResultList = res.Result || [];
          // if (this.calibrateResultList && this.calibrateResultList.length > 0) {
          //   this.calibrateResultList.forEach((item, index) => {
          //     const data = res.Result.find(d => d.Id === item.Id) || {};
          //     if (!!data) item.Value = data.Value;
          //   });

          // } else { 
          //   this.calibrateResultList = res.Result || [];
          // }
        }
        
        if (param.statusType == '0x0700' && res.Result instanceof Array && res.Result.length > 0) {
          this.calibrateTempResultList = res.Result
        }
      } else {
        alerterror(this, res.StatusCode)
      }
    },
    functionDoGetDataSampleList (rs, param) {
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        if (param.statusType == '0x0600') {
          if (rs.Result instanceof Array) {
            this.calibrateResultList = rs.Result
          }
        } else if (param.statusType == '0x0700') {
          if (rs.Result instanceof Array && rs.Result.length > 0) {
            this.calibrateTempResultList = rs.Result
          }
        }
      } else {
        alerterror(this, rs.StatusCode)
      }
    },

    onMidSecretSuccess() {
      this.doFindConfigAbility(2);
    },

    mountedDo (shown) {
      if (shown == true) {
        this.isdisplay = true
      }

      // 获得设备详情；OTA 首次查询由 OppleOtaCards.init 完成，避免与 refreshOtaCards 重复请求
      this.doFindDevice(shown)
      // socket.on('sync_info_event', this.functionScoketsync_info_event);
      // this.doOTAVersion()
      // 弹窗「刷新」走 cardsetResresh → mountedDo(true)，此时再刷新 OTA
      if (shown === true) {
        this.refreshOtaCards()
      }
      this.noOtaList = this.$store.state.staticConfig.OtaConfig.HideSKU || []
      this.requestDeviceAllInfo();
    },

    refreshOtaCards() {
      this.$nextTick(() => {
        const refreshCard = ref => {
          const card = Array.isArray(ref) ? ref[0] : ref;
          if (card && typeof card.doOTAVersion === 'function') {
            card.doOTAVersion(true);
          }
        };

        refreshCard(this.$refs.OppleOtaCards);

        (this.childDeviceList || []).forEach(item => {
          refreshCard(this.$refs[item.ref]);
        });
      });
    },

    async requestDeviceAllInfo() {
      try {
        const res = await FindDeviceAbilityByVDeviceId({
          VDeviceId: this.devicemodel.VDeviceId,
        });

        if (res && res.StatusCode === 0 && res.Result) {
          const { ActionSet, TriggerSet, ConfigSet, StatusSet, IsSupportResetDevicesInChannel, UISet } = res.Result;

          if (ActionSet === null && TriggerSet === null && ConfigSet === null && StatusSet === null) {
            this.isNoAbilityDevice = true;
          }

          this.ActionSet = ActionSet;
          this.isShowChildReset = !! IsSupportResetDevicesInChannel;
          this.UISet = UISet;
        }

      } catch (e) {

      }
    },

    /* 格式化mac
     * val:mac源数据
     */
    macformate (val) {
      return formateMac(val)
    },
    /* 格式化设备状态信息
     */
    formatedevicestatus () {
      // 格式化设备状态
      if (
        this.model.StatusInfo != null &&
        this.model.StatusInfo instanceof Array
      ) {
        let isReturn = false
        this.model.StatusInfo.forEach((n) => {
          if (n.StatusType == '0x0600') {
            this.getilluminationValue(n)
          } else if (n.StatusType == '0x0700') {
            this.gettemperatureValue(n)
          } else if (n.StatusType == '0x1600' || n.StatusType == '0x1601') {
            // 上电时长 界面将秒转成小时
            this.getpowertimeValue(n)
          }else if(n.StatusType == '0x0215'){
            // 判断是否显示tips
            if(n.hasOwnProperty('Value1') && n.Value1  !='254'){
              this.showTips = true
            }else if(!n.hasOwnProperty('Value1') && n.Value !='254'){
              this.showTips = true
            }
          }
          isReturn = false
          this.$store.state.deiveStatus.forEach((m) => {
            if (m.Key == n.StatusType) {
              for (let i = 0; i < m.Value.length; i++) {
                if (m.Value[i].Value != undefined) {
                  if (m.Value[i].Value == n.Value) {
                    n.Value1 = n.Value
                    n.Value = m.Value[i].Key
                    n.ParaUnit = ''
                    isReturn = true
                  }
                } else {
                  const _value = Number(n.Value)
                  if (_value >= m.Value[i].Min && _value <= m.Value[i].Max) {
                    n.Value1 = n.Value
                    n.Value = '(' + m.Value[i].Key + ')' + ' ' + _value + ' '
                  }
                }
              }
            }
          })
          if (isReturn == true) {
            return
          }

          this.$store.state.deiveStatus.forEach((m) => {
            if (m.Key == n.StatusType.substring(0, 4)) {
              // 匹配大类
              for (let i = 0; i < m.Value.length; i++) {
                if (m.Value[i].Value != undefined) {
                  if (m.Value[i].Value == n.Value) {
                    n.Value1 = n.Value
                    n.Value = m.Value[i].Key
                    n.ParaUnit = ''
                  }
                } else {
                  const _value = Number(n.Value)
                  if (_value >= m.Value[i].Min && _value <= m.Value[i].Max) {
                    n.Value = '(' + m.Value[i].Key + ')' + ' ' + _value + ' '
                  }
                }
              }
            }
          })
        })

        //根据拿到的UI能力表排序
        if(this.UIAbiliy?.statusListSort?.statuscodes){
          this.model.StatusInfo = this.sortStatus(this.UIAbiliy,this.model.StatusInfo)
        }
        // 根据新的UIconfig Status配置进行排序显示隐
       if(this.UIAbiliy && this.UIAbiliy?.WebUIConfigV2 && this.UIAbiliy?.WebUIConfigV2?.StatusContainer){
          const {items} = this.UIAbiliy.WebUIConfigV2.StatusContainer
          if(items && Array.isArray(items) && items.length > 0){
          const jsonStatus = {}
          items.forEach((item ,index)=> {
            jsonStatus[item.code] = {
              ...item,
              statusSort:999-index

            }
          })
          this.model.StatusInfo.forEach((item)=>{
            if(jsonStatus[item.StatusCode]){
              item.statusSort = jsonStatus[item.StatusCode].statusSort
            }
          })
          this.model.StatusInfo.sort((a,b)=>{
            const aSort = a.statusSort || 0
            const bSort = b.statusSort || 0
            return bSort - aSort
          })
          this.model.StatusInfo = this.model.StatusInfo.filter(item => item.hasOwnProperty('statusSort'))
          }
       }
      }
    },


    sortStatus(orderSpecification,originalData){
      // Create a dictionary for efficient lookup
      const orderDict = {};
      orderSpecification.statusListSort.statuscodes.forEach((code, index) => {
        orderDict[code] = index;
      });

      // Define a sorting function
      function statusSortFunction(item) {
        const code = item.StatusCode || "";
        return orderDict[code] !== undefined ? orderDict[code] : Number.POSITIVE_INFINITY;
      }

      // Sort the original data
      const sortedData = originalData.sort((a, b) => statusSortFunction(a) - statusSortFunction(b));

      // Print or use the sorted data as needed
      console.log(sortedData);
      return sortedData
    },
    /* 获得设备详情 接口返回数据处理 查询设备的配置 action
     * rs:接口返回的数据包
     */
    functionDoFindDevice (rs, param) {
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        if (rs.Result != null) {
          this.model = rs.Result
          if (
            this.model.ChildCategoryType == 128 &&
            this.model.SensorTypes != null
          ) {
            if (this.model.SensorTypes.indexOf(2) >= 0) {
              this.calibrateReferAbility = true
            }
            if (this.model.SensorTypes.indexOf(8) >= 0) {
              this.calibrateTempReferAbility = true
            }
          }
          if (this.model.StatusInfo) {

            if (this.model.ChildId != 65535) {
              const _status = []
              JSON.parse(this.model.StatusInfo).forEach((n) => {
                if (n.ChannelId == 65535) {
                  _status.push(n)
                } else if (n.ChannelId == this.model.ChildId) {
                    _status.push(n)
                  }
              })
              this.model.StatusInfo = _status
            } else {
              this.model.StatusInfo = JSON.parse(this.model.StatusInfo);
            }
            //欧洲隐藏 BLE信号强度
            if(!this.$store.state.signalStrengthConfig){
              this.model.StatusInfo = this.model.StatusInfo.filter(item => item.StatusType !== '0x1D01')
            }
            this.calibrateReferAbility = !!this.model.StatusInfo.find((n) => {
              return n.StatusType == '0x0600'
            })

            this.formatedevicestatus()
          }

          if (param.noReaction != true) {
            this.doFindActionAbilityWithStatus()
            this.dosocketaction()
            this.dosocketTranscode()
            this.dosocketScence()
            if (this.model.ChildId == this.$store.state.channleid) {
              this.doFindConfigAbility()
            } else {
              this.isConfiguration = false
              this.isOta = false
            }
          }
        }
        this.handleTianMu()
      }
      this.$store.dispatch('changeLoadingdetail', false)
      this.isdisplay = true
      filterSensorStatus(this.model)
    },
    /* 获得设备详情
     */
   async doFindDevice (shown, noReaction) {
      // 获得设备详情
      if (shown != true) {
        this.isdisplay = false
      }
      this.$store.dispatch('changeLoadingdetail', true)
      let para = {
        noReaction,
        vDeviceId: this.devicemodel.VDeviceId,
        channelId: this.devicemodel.ChildId
      }
      this.devicemodel

      const UIABILITY =  await Finduiability({vDeviceId: this.devicemodel.VDeviceId})
      const UIAbiliyRes = UIABILITY.Result;
      this.UIAbiliy = UIAbiliyRes;
      // this.webInnoConfigInnoPro = webInnoConfigInnoPro?.webInnoConfigInnoPro

      if (
        UIAbiliyRes &&
        UIAbiliyRes.uiAction &&
        Array.isArray(UIAbiliyRes.uiAction.relationAction) &&
        UIAbiliyRes.uiAction.relationAction.length > 0
      ) {
        this.relationAction = UIAbiliyRes.uiAction.relationAction;
      }

      if(UIAbiliyRes && UIAbiliyRes.RelationLimit){
        this.relationLimit = UIAbiliyRes.RelationLimit;
      }
      if(UIAbiliyRes && UIAbiliyRes.RelationScreen){
        this.RelationScreen = UIAbiliyRes.RelationScreen;
      }
      if(UIAbiliyRes && UIAbiliyRes.webInnoConfig){
        this.webInnoConfig = UIAbiliyRes.webInnoConfig;
      }
      if(UIAbiliyRes && UIAbiliyRes.webInnoConfigV2){
        this.webInnoConfigV2 = UIAbiliyRes.webInnoConfigV2
      }
      if(UIAbiliyRes && UIAbiliyRes.WebUIConfig){
        this.webInnoConfigInnoPro = UIAbiliyRes.WebUIConfig?.webInnoConfigInnoPro
      }
      if (UIAbiliyRes?.webControlAreaConfig?.length) {
        this.webControlAreaConfig = UIAbiliyRes.webControlAreaConfig
      }
      console.log('this.UIAbiliy', this.UIAbiliy ,this.relationAction);

      FindDevice(para, this.functionDoFindDevice)
      para = null
    },
    /* 获得设备版本号（已迁移至 OppleOtaCards，保留方法供历史引用）
     */
    // async doOTAVersion () {
    //   let para = { vDeviceId: this.devicemodel.VDeviceId, searchIp: false }
    //   BatchSearchFirmwareVersion(para, this.doBatchSearchFirmwareVersion)
    //   GetFirmwareVersionFromDevice(para, 1).then((res) => {
    //     if (res.StatusCode == this.$store.state.rightStatusCode && res.Result.IP != null) {
    //       this.LocalIp = res.Result.IP || ''
    //     }
    //   });
    // },
    // doBatchSearchFirmwareVersion (rs) { ... },
    /* 以下 OTA 版本查询 / 启停 / socket 移除（已迁移至 OppleOtaCards）
    doSearchFirmwareVersionFunction (rs) {
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        if (rs.Result != null) {
          if (rs.Result.Version != null) {
            this.LocalVersion = rs.Result.Version
          }
          if (rs.Result.Ip != null) {
            this.LocalIp = rs.Result.Ip
          }
          if (rs.Result.IpFieldCode != null) {
            this.IpFieldCode = rs.Result.IpFieldCode
          }
        }
      } else {
        alerterror(this, rs.StatusCode)
      }
    },
    doSearchCloudOtaVersionFunction (rs) {
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        this.CloudVersion = ''
        if (rs.Result != null) {
          this.CloudVersion = rs.Result.Version
        }
      } else {
        alerterror(this, rs.StatusCode)
      }
    },
    removeSocket() {
      postWebIOSocket('sync_info_remove_event', {
        data: [
          {
            projectCode: this.$store.state.projectcode,
            type: 6,
            id: this.model.DeviceId
          }
        ]
      })
    },
    */
    /* 注册socket信息
     */
     dosocketaction () {
      // socket.emit('sync_info_add_event', { data: [{ projectCode: this.$store.state.projectcode, type: 1, id: this.model.VDeviceId }] });
      postWebIOSocket('sync_info_add_event', {
        data: [
          {
            projectCode: this.$store.state.projectcode,
            type: 6,
            id: this.model.DeviceId
          }
        ]
      })
    },
    /* 停止 / 取消 OTA（已迁移至 OppleOtaCards）
    stopota () {
      this.firmwareVersion.VersionList.forEach(item => {
        item.isloadingota = true
        item.isStop =  true
      })
      this.isstop = true
      this.isloadingota = true
      this.levelpross = 0
      this.customColor = ''
      this.leveltitle = this.infor_upgrade
    },
    cancleOta () {
      let para = { childDeviceIds: this.model.VDeviceId }
      StopOta(para, this.functionDoStopOta)
      para = null
    },
    functionDoStopOta (rs) {
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        this.levelcode = ''
        this.stopota()
        alertsuccess(this, rs.StatusCode)
      } else {
        alerterror(this, rs.StatusCode)
      }
    },
    */
    /* 监听socket信息 数据推送处理
     * rs :推送过来的数据包
     */
    async functionScoketsync_info_event (rs) {
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        if (rs.Result) {
          // Type 6 OTA 推送已由 OppleOtaCards.handlerSocket 处理
          if (rs.Result[0].Type == 6) {
          } else if (rs.Result[0].Type == 11) {
            if (this.model.VDeviceId == rs.Result[0].VDeviceId) {
              rs.Result[0].StatusInfo.forEach((n) => {
                if (this.model.StatusInfo) {
                  this.model.StatusInfo.forEach((m) => {
                    // if (m.StatusCode == n.StatusCode) {
                    // 	m.Value = n.Value;
                    // }
                    // if(m.StatusCode == "0x0000"){
                    //   this.model.IsOnline = (n.Value == "0x0000"?true:false);
                    // }
                    if (
                      m.StatusType == n.StatusType &&
                      m.ChannelId == n.ChannelId
                    ) {
                      m.Value = n.Value
                      
                      if (m.StatusType === '0x0600') {
                        try {
                          const data = JSON.parse(n.Value || '{}');

                          this.calibrateLUXListen(data.OriginValue, data.CorrectionValue, data.IsCorrected);
                        } catch (e) {
                        }
                      }
                      
                      if (
                        m.StatusType == '0x1600' ||
                        m.StatusType == '0x1601'
                      ) {
                        m.ParaUnit = 's'
                      }
                      if (m.StatusType == '0x0100') {
                      //todo 应该是StatusType
                      this.model.IsOnline = n.Value == '1'
                        // if(!this.model.IsOnline && !this.isloadingota && !this.isstop){
                        //   error(this, this.infor_ingfail)
                        //   this.stopota()
                        // }
                      }
                    }
                    // if (m.StatusCode == '0x0100') {
                    //   //todo 应该是StatusType
                    //   this.model.IsOnline = n.Value == '1'
                    // }
                    // if (m.StatusType == '0x0100') {
                    //   //todo 应该是StatusType
                    //   this.model.IsOnline = n.Value == '1'
                    //   if(!this.model.IsOnline){
                    //     error(this, this.infor_ingfail)
                    //     this.stopota()
                    //   }
                    // }
                  })
                }
                // 设备能力接受实时推送
                // this.ActionList.forEach(p => {
                // 	if(p.ChannelId==n.ChannelId){
                // 		p.ActionList.forEach(m => {
                // 			m.Values.forEach(t => {
                // 				if (t.Type==n.StatusType) {
                // 					 console.log('.....设备能力接受实时推送',t.Name,n.Value,)
                //            t.DefaultValue = +n.Value
                //           //  t.IsShow = n.IsShow
                // 				if (t.Type==n.StatusType) {
                // 					 console.log('.....设备能力接受实时推送',t.Name,n.Value,)
                //            t.DefaultValue = +n.Value
                //           //  t.IsShow = n.IsShow
                // 				}
                // 			});
                // 		});
                // 	}
                // });
              })
              this.formatedevicestatus()
            }
          } else if (rs.Result[0].Type == 10) {
            // 在线状态
            if (this.model.VDeviceId == rs.Result[0].VDeviceId) {
              this.model.IsOnline = rs.Result[0].IsOnline
            }
          } else if (rs.Result[0].Type == 14) {
            // 真实虚拟设备
            if (this.model.VDeviceId == rs.Result[0].VDeviceId) {
              this.model.IsBind = rs.Result[0].IsBind
            }
          } else if (rs.Result[0].Type == 15) {
            // 修改名称
            if (
              this.model.VDeviceId == rs.Result[0].VDeviceId &&
              this.model.ChildId == rs.Result[0].ChannelId
            ) {
              if (this.model.ChildId == 65535) {
                this.model.DeviceName = rs.Result[0].SyncInfo
              } else {
                this.model.ChildName = rs.Result[0].SyncInfo
              }
            }
          }
        }
      }
    },
    /* 页面点击升级ota（已迁移至 OppleOtaCards）
    otaupdate () {
      this.donewOta()
    },
    */
    /* 注册socket信息
     */
    // dosocketaction () { 
    //   // socket.emit('sync_info_add_event', { data: [{ projectCode: this.$store.state.projectcode, type: 1, id: this.model.VDeviceId }] });
    //   postWebIOSocket('sync_info_add_event', {
    //     data: [
    //       {
    //         projectCode: this.$store.state.projectcode,
    //         type: 6,
    //         id: this.model.DeviceId
    //       }
    //     ]
    //   })
    // },
    //监听场景变化
    dosocketScence() {
      const socketpara = {
        data:[]
      }
      socketpara.data.push({ 
        projectCode: this.$store.state.projectcode, 
        type: 19, 
        id: this.$store.state.projectcode 
      });
       if (socketpara.data.length > 0) {
        postWebIOSocket('sync_info_add_event', socketpara);
      }
    },
    dosocketTranscode () { 
      const SocketNotifyCommonType = 40 // 监听通用类型
      const SocketNotifyDeviceFailureChildType = 'wellsky:scenebin' // 设备故障子监听类型
      // socket.emit('sync_info_add_event', { data: [{ projectCode: this.$store.state.projectcode, type: 1, id: this.model.VDeviceId }] });
      const pid = this.$store.state.projectcode
      const param = {
          projectCode: pid,
          type: SocketNotifyCommonType,
            data: [{
                id: pid,
                idType: 'ProjectCode',
                notifyType: SocketNotifyDeviceFailureChildType
              }]
            }
      postWebIOSocket('sync_info_add_event', param)
    },
    /* 发起 OTA / socket 状态（已迁移至 OppleOtaCards）
    dosocket () {
      this.isstop = false
      this.isloadingota = false
      let _temp = getLocalStoragItem('upOtaDeviceInfo')
      if(_temp != null && this.devicemodel.VDeviceId == _temp.VDeviceId && this.upOTAIndex == _temp.upOTAIndex && !this.isstop && this.firmwareVersion.VersionList[this.upOTAIndex]){
        this.firmwareVersion.VersionList[this.upOTAIndex].isloadingota = false
        this.firmwareVersion.VersionList[this.upOTAIndex].isStop = false
      }
      this.leveltitle = this.$t('deviceMsg.issued')
    },
    functionDoStartOta (rs) {
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
      } else {
        alerterror(this, rs.StatusCode)
      }
    },
    donewOta () {
      this.levelcode = this.CloudVersion
      this.doStartOta()
    },
    doStartOta (e,index) {
      this.upOTAIndex = index
      let temp = {VDeviceId:this.devicemodel.VDeviceId,upOTAIndex:index}
      setLocalStoragItem("upOtaDeviceInfo", JSON.stringify(temp));
      this.stopota()
      let para = { vDeviceId: this.model.VDeviceId, mode: 0}
      if (this.$store.state.isDebugMode == true) {
        para.mode = 1
      }
      try {
        if(e != null){
          this.firmwareVersion.VersionList[index].isloadingota = false
          this.firmwareVersion.VersionList[index].isStop = false
          para.SourceType = e.SourceType
          this.levelcode = e.SourceType
        }else{
          para.SourceType = this.firmwareVersion.VersionList[0].SourceType
        }
      } catch (error) {
        console.log("🚀 ~ file: deviceMsg.vue:2798 ~ doStartOta ~ error:", error)
      }

      this.dosocket()
      StartOta(para, this.functionDoStartOta)
      para = null
    },
    */
    /* action启停 按钮点击
     */
    startstopclick (model, _type) {

      if (_type == 1) {
        // 启动
      } else {
        // 停止
      }
      this.doCallAction(model)
    },
    /* action 步进按钮点击
     */
    steppingclick (fmodel, model, _type) {
      model.DefaultValue = _type
      this.doCallAction(fmodel)
    },
    /* 格式化action接口返回回来的数据格式 将值改为number 不然浏览器会有报错
     * arry ： 原始数据
     */
    functionfilter (arry) {
      // 筛选数组 将不显示的对象去除  DefaultValue格式化转成int
      // arry.forEach(n => {
      // 	n.ActionList.forEach(model => {
      // 		for (let i = 0; i < model.Values.length; i++) {
      // 			if (!model.Values[i].IsShow) {
      // 				model.Values.splice(i, 1);
      // 			}
      // 		}
      // 	});
      // });
      // 专业版才会展示的内容
      const filterArry = arry.map(item => {
        // 不用浅拷贝，直接操作原 item
        item.ActionList = (item.ActionList || []).filter(
          model => this.$store.state.isProfessional || !ProfessionalOnlyMsgType.includes(model.MsgType)
        )
        return item // 保持响应式引用
      })


      filterArry.forEach((n) => {
        n.ActionList.forEach((model) => {
          for (let i = 0; i < model.Values.length; i++) {
            model.Values[i] =  new ActionVo(model.Values[i]);
            // this.LightActionValueReady(model, i)
            switch (model.Values[i].ValueType) {
              case 'UIControl_RadioboxList':
              case 'UIControl_SliderAndInput':
              case 'UIControl_Slider':
              case 'UIControl_Switch':
              case 'UIControl_Bright':
              case 'UIControl_ColorTemperature':
              case 'UIControl_MotorTrace_Slider':
              case 'UIControl_MotorVerticalTrace_Slider':
              case 'UIControl_MotorAngle_Slider':
                model.Values[i].DefaultValue = Number(model.Values[i].DefaultValue);
                break;
              case 'UIControl_CXCY_Color_Multiple_ChooseV2':
              case 'UIControl_CXCY_Color_Multiple_Choose':
              case 'UIControl_Color_RGB_WithMode':
              case 'UIControl_RGB_Color_Multiple_Choose':
                model.Values[i].DefaultValue = model.Values[i].DefaultValue;
                break;
              case 'UIControl_ColorPanel':
                // do nothing
                break;
              default:
               model.Values[i].DefaultValue = Number(model.Values[i].DefaultValue);
                break;
            }
          }
        })
      })

      return filterArry
    },
    functionSaveOrUpdateDataSample (rs) {
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        alertsuccess(this, rs.StatusCode)
        this.calibrateShow(false)
      } else {
        alerterror(this, rs.StatusCode)
      }
    },
    /* action下发设备 接口返回回来的数据处理
     * rs ： 接口返回数据
     */
    functionDoCallAction (rs) {
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        alertsuccess(this, rs.StatusCode)
        // this.calibrateShow(false);
      } else {
        alerterror(this, rs.StatusCode)
      }
    },

    handleClickRadio:debounce(function (item) {
      this.doCallAction(item)
    }, 300),

    /* 执行action下发设备
     * item：需要下发的数组
     */
    doCallAction (item,ref) {
      if(item.UI != null &&item.UI.NoneNeedCallAction == true){
        return
      }

      if (this.guardTianMuPlayerAction(item)) {
        return
      }

     // let _values = ''
     const valueList = [];
      let callNext = true
      
      item.Values.forEach((tem) => {
        /* SDL灯带含有颜色的需要拥有颜色才能下发其他action，251925264为能力表默认值 */
        if( UICONTROL_CX_CY_Multiple_CHOOSE_ARRAY.includes(tem.ValueType)  && (tem.DefaultValue == '251925264' || tem.DefaultValue == '0')){
          callNext = false
        }

        const submitData = typeof tem?.getSubmitData === 'function'
          ? tem.getSubmitData()
          : ActionVo.getSubmitData(tem)
        const { Value } = submitData
        // const _temvalue =this.LightActionValueSubmit(tem)
        // console.log('_temvalue', _temvalue);
        // console.log('tem', _temvalue);

        // if (_values == '') {
        //   _values = Value + ''
        // } else {
        //   _values += ',' + Value
        // }

        valueList.push(Value);
      })

      let para = {
        vDeviceId: this.model.VDeviceId,
        msgType: item.MsgType,
        channelId: this.model.ChildId,
        values: valueList.join(',')
      }
      if(callNext){
        CallAction(para, this.functionDoCallAction)
      }
      //针对于el-slider
      if(ref){
        if(Array.isArray(this.$refs[ref])){
          setTimeout(() => {
            this.$refs[ref][0] && this.$refs[ref][0].$refs["button1"] && this.$refs[ref][0].$refs["button1"].handleMouseLeave()
          }, 500);
        }
      }
    },
    /**
     * 新的下发设备方法
     * @param {*} tem  当前操作的action
     * @param {*} info 暂无
     * @param {*} model 暂无
     * @param {*} _type value类型
     * @param {*} color 颜色
     * @param {*} value
     */
     doCallActionClassSku(tem,info, model, _type,color,value) {
      debugger
      if (this.UIAbiliy && this.UIAbiliy.UIConfigV2 && this.UIAbiliy.UIConfigV2.control_space) {
        const control_space = Number(this.UIAbiliy.UIConfigV2.control_space) || 0;

        // this.control_space_time = 0;

        let curtTime = 0;

        this.progressInterval && clearInterval(this.progressInterval);
        this.progressInterval =  setInterval(() => {
          curtTime += 1;
          const progress = Number((curtTime / control_space).toFixed(2)) * 100;
          console.log('过了', progress, curtTime, control_space);
          this.control_space_progress = Number(progress.toFixed(0));

          if (control_space < curtTime) {
            console.log('过了 !!!');
            this.control_space_progress = null;
            clearInterval(this.progressInterval);
          }

        }, 1000);
      }

      if(tem.UI != null &&tem.UI.NoneNeedCallAction == true){
        return
      }
      this.doCallAction(tem)
    },
    /* 执行action下发设备
     * item：需要下发的数组
     */
    actionSave (item) {
      this.doCallAction(item)
    },
    /* 开关执行action下发设备
     * item：需要下发的数组
     */
    handleActionSwitch (model, item) {
      // action开关事件
      if (item.Values.length == 1) {
        // 自动提交
        this.actionSave(item)
      }
    },
    /* 滑动条执行action下发设备
     * item：需要下发的数组
     */
    handleSlider (model, item) {
      // action滑块滑动事件
      if (item.Values.length == 1) {
        this.actionSave(item)
      }
    },
    // num_less(model) {
    // 	if (this.model.DefaultValue > model.Min) {
    // 		this.model.DefaultValue -= 1;
    // 	} else {
    // 		this.model.DefaultValue = model.Min;
    // 	}
    // },
    // num_add(changeNum) {
    // 	this.changeNum++;
    // },
    /* 点击显示更多
     */
    showMore () {
      this.showAll = !this.showAll
    },
    /* 设备参数 下拉框事件 控制input框显示隐藏
     */
    handleselect (event, item) {
      if (event != null && item != null) {
        item.DefaultValue = event
      }
      // 下拉框事件 控制input框显示隐藏
      this.GpDetails.GpDetails.forEach((model) => {
        if (model?.ShowCondition?.KeyId && model.ShowCondition.KeyId != 0) {
          if (model?.ShowCondition?.KeyId == item.KeyId) {
            if (item.DefaultValue == model?.ShowCondition?.KeyValue) {
              model.isDisplay = true
              model.hasChanged = true;
            } else {
              model.isDisplay = false
               model.hasChanged = false;
            }
          }
          // if (model.ShowCondition.KeyId == item.KeyId && item.DefaultValue == model.ShowCondition.KeyValue) {
          // 	model.isDisplay = true;
          // } else {
          // 	model.isDisplay = false;
          // }
        }
      })
      this.ComparisonData()
    },
    /* 比较数据有没有发生变化 如果没有发生变化提交按钮不可点击 如果有左边icon标识该数据已修改未提交
     */
    ComparisonData () {
      for (let i = 0; i < this.olddata.length; i++) {
        if (this.olddata[i].GpNo == this.GpDetails.GpNo) {
          let _isreset = true // 是否还原
          for (let n = 0; n < this.GpDetails.GpDetails.length; n++) {
            if (
              this.olddata[i].GpDetails[n].DefaultValue !=
              this.GpDetails.GpDetails[n].DefaultValue
            ) {
              _isreset = false
              break
            }
          }
          if (_isreset) {
            this.param[i].isEditor = false
          } else {
            this.param[i].isEditor = true
          }
        }
      }
    },
    /* 设备参数 开关事件
     */
    handleChange (item) {
      console.log("🚀 ~ file: deviceMsg.vue:3051 ~ handleChange ~ item:", item)
      let startIndex = 0
      for (const model of this.GpDetails.GpDetails) {
        if (model === item) break
        if (model.ValueType === 'MultipleEnum' || model.ValueType === 'UIControl_MultipleBitEnum_ReverseSwitch') {
          startIndex += (model.EnumValue || []).length
        }
      }
      const slice = this.defaultcheck.slice(startIndex, startIndex + (item.EnumValue || []).length)
      let _tem
      if (item.ValueType === 'UIControl_MultipleBitEnum_ReverseSwitch') {
        item.DefaultValue = slice.reduce((acc, val) => acc | Number(val), 0)
        _tem = slice.filter((v) => v != -1)
      } else {
        _tem = slice.filter((v) => v != -1)
        item.DefaultValue = _tem.length ? _tem.join(',') : '0'
      }
      this.GpDetails.GpDetails.forEach((model) => {
        if (model?.ShowCondition?.KeyId && model.ShowCondition.KeyId != 0) {
          if (
            model.ShowCondition.KeyId == item.KeyId &&
            _tem.indexOf(model.ShowCondition.KeyValue) != -1
          ) {
            model.isDisplay = true
          } else {
            model.isDisplay = false
          }
          this.$forceUpdate()
        }
      })
      _tem = null
      this.ComparisonData()
    },
    /* 设备参数 input事件
     */
    handleInput () {
      this.ComparisonData()
    },
    /* 获得设备action能力 接口返回数据处理
     * rs : 接口返回数据包
     */
    functionDoFindActionAbilityWithStatus (rs) {
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        if (rs.Result != null) {
          let result = rs.Result

          this.addAirConditionActionAbilityTest(result, true)
          const actionList = this.functionfilter(result);
          const defaultList = [];
          const UIControl_WithoutStatus_ButtonList = [];
          let curtainList = [];

          actionList.forEach(item => {
            const ActionList = item.ActionList || [];

            if (
              ActionList[0] &&
              ActionList[0].UI &&
              ActionList[0].UI.ActionGroup === "UIControl_NoSeparator_RowLayout"
              // ActionList[0].Values[0].ValueType === 'UIControl_WithoutStatus_Button'
            ) {
              UIControl_WithoutStatus_ButtonList.push(item);
            } else {
              defaultList.push(item);
            }
          });

          UIControl_WithoutStatus_ButtonList.forEach(item => {
            // item.ActionList.filter(item => {
            //   return item.IsShow === true
            // })

            // item.ActionList[0].Values = item.ActionList[0].Values.filter(item => {
            //   return item.IsShow === true
            // })

            curtainList.push(item.ActionList[0]);
            // curtainList = curtainList.concat(item.ActionList);
          });

              // return {
              //   ChannelId: item.ChannelId,
              //   ActionList: item.ActionList.map(item => )
              // }
          // console.log('functionDoFindActionAbilityWithStatus', actionList);
          this.OtaActionList = actionList
          this.ActionList = defaultList;
          this.curtainList = curtainList;

          result = null
          this.isaction = true

          const matched = []
          const rest = []

          this.ActionList.forEach(item => {
            const hasAction = item?.ActionList?.[0]?.Values.some(item=>{
              return item.ValueType === "UIControl_TianMu_Loop" || item.ValueType === 'UIControl_TianMu_PlaybackSpeed' || item.ValueType === 'UIControl_TianMu_Video_Group'
            })

            if (hasAction) {
              matched.push(item)
            } else {
              rest.push(item)
            }
          })

          this.tianmuDynamicActionList = matched
          this.ActionList = rest


          //过滤只在详情显示action
          this.ActionList = this.ActionList.filter(item=>{
            if(item.ActionList && item.ActionList.length>0){
              return  getDeviceShowMode(item.ActionList[0])
            }
            return false
          })
       }
      }
    },
    /* 获得设备action能力
     */
    doFindActionAbilityWithStatus () {
      this.ActionList = []
      this.isaction = false
      let para = {
        classSku: this.model.ClassSku,
        vDeviceId: this.model.VDeviceId,
        channelId: this.model.ChildId
      }
      FindActionAbilityWithStatus(
        para,
        this.functionDoFindActionAbilityWithStatus
      )
      para = null
    },
    /* 获得设备参数 接口返回数据处理
     * rs : 接口返回数据包
     */
    functionDoFindConfigAbility (rs) {
      // 改改改
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        if (rs.Result != null) {
          this.configAbility = rs.Result;
          //BatchSearchFirmwareVersion缓慢 重启按钮判断使用的新接口FindConfigAbility
          // this.deviceReboot = rs.Result.Reboot

          if(rs.Result.UIGuide){
            this.otaBoot = true
          }

          // // 是否展示替换
          // this.isShowReplace = typeof rs.Result.ReplaceSupport === 'boolean' ? rs.Result.ReplaceSupport : true;

          if (rs.Result.GpList && rs.Result.GpList.length > 0) {
            // let abilityNeighborGroup = this.$refs.abilityNeighborGroup[0]
            console.log("🚀 ~ file: deviceMsg.vue:3121 ~ functionDoFindConfigAbility ~ abilityNeighborGroup:", this.$refs)
            // if(abilityNeighborGroup){
            //   // abilityNeighborGroup.isShowNeighborGroup = +this.findConfigKeyIdDefaultValue(rs.Result.GpList,225)
            //   abilityNeighborGroup.neighborDefalutValue = decodeNeighborGroup(this.findConfigKeyIdDefaultValue(rs.Result.GpList,226))
            //   console.log("🚀 ~ file: deviceMsg.vue:3125 ~ functionDoFindConfigAbility ~ decodeNeighborGroup(this.findConfigKeyIdDefaultValue(rs.Result.GpList,226)):", decodeNeighborGroup(this.findConfigKeyIdDefaultValue(rs.Result.GpList,226)))
            // }
            // this.olddata = JSON.parse(JSON.stringify(rs.Result.GpList)) // 直接复制会导致绑定到数据模型
            this.isConfiguration = true
            let _arry = []
            rs.Result.GpList.forEach((item) => {
              item.isEditor = false

              if (this.$store.state.isProfessional || !ProfessionalOnlyGpName.includes(item.GpName)) {
                _arry.push(item)
              }
            })
            this.checkWiftDialog(_arry)

            this.param = _arry
            this.olddata = JSON.parse(JSON.stringify(rs.Result.GpList)) // 直接复制会导致绑定到数据模型
            this.setIsConfiguration(rs.Result.GpList)
            this.setScreenSetting(rs.Result.GpList)
            _arry = null
            // } else {
            // 	this.isConfiguration = false;
          }
        }
      }
    },

    setIsConfiguration(arr) {

      let _sum = arr.reduce((acc, item) => {
        item.GpDetails.forEach(val => {
          if (val.IsShow && (val.isDisplay === undefined ? true : val.isDisplay)) {
            acc++;
          }
        });
        return acc;
      }, 0);

      this.isConfiguration = _sum > 0;
    },
    /**
     * 设置显示屏幕设置
     * @param {Array} list GpDetails
     */
     setScreenSetting(list){
      // list.forEach(item => {
      //   item.GpDetails.forEach(val => {
      //     const {ValueType,KeyId } = val;
      //     if (ValueType === 'UIControl_ConfigScreenSetting') {
      //       this.ScreenSetting = val
      //     }
      //   });
      // });
      if(this.RelationScreen && this.RelationScreen.prefetchRelationScreen){
        const {GpKeyId,GpNo} = this.RelationScreen.prefetchRelationScreen;
        const info = list.find(gp => gp.GpNo == GpNo)?.GpDetails.find((detail) => detail.KeyId == GpKeyId)
        if(info){
          this.ScreenSetting = info
        }
      }
    },
    findConfigKeyIdDefaultValue(list,KeyId){
     // 查找包含 ValueType 为 "UIControl_NeighborGroupInput" 的对象
      const targetObject = list.find(group => {
        const detail = group.GpDetails.find(detail => detail.KeyId === KeyId);
        return detail !== undefined;
      });

      // 获取 DefaultValue
      let defaultValue;
      if (targetObject) {
        const detail = targetObject.GpDetails.find(detail => detail.KeyId === KeyId);
        if (detail) {
          defaultValue = detail.DefaultValue;
        }
      }
      return defaultValue
    },
    checkWiftDialog(arr) {
      const wifiDataIndex = arr.findIndex(item => isWifiConfig(item));

      if (wifiDataIndex === -1) return;
      console.log('wifiDataIndex', wifiDataIndex);

      const wifiName_key_22 = arr[wifiDataIndex].GpDetails.find(item => item.IsShow &&
        item.UI &&
        item.UI.ConfigType === 3
      )
      const wifiName = arr[wifiDataIndex].GpDetails.find(item => item.IsShow &&
        item.ParaType === 'String' &&
        item.ValueType === 'Input' &&
        item.UI &&
        item.UI.ConfigType === 1
      )

      if ((wifiName && !wifiName.DefaultValue) &&  (wifiName_key_22 && !wifiName_key_22.DefaultValue)) {
        this.$message({
          type: 'warning',
          message: this.$t('deviceMsg.pleaseSetWifi')
        })

        setTimeout(() => {
          this.activeParam = wifiDataIndex;
          this.GpDetails = arr[wifiDataIndex];
        }, 1000)
      }
    },

    /* 获得设备参数 接口返回数据处理
     * rs : 接口返回数据包
     */
    functionDoFindConfigAbilityTolddata (rs) {
      // if (rs.StatusCode == this.$store.state.rightStatusCode) {
      //   if (rs.Result != null) {
      //     if (rs.Result.GpList.length > 0) {
      //       this.olddata = JSON.parse(JSON.stringify(rs.Result.GpList)) // 直接复制会导致绑定到数据模型
      //       this.isConfiguration = true
      //     }
      //   }
      // }
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        alertsuccess(this, rs.StatusCode)
        if (rs.Result != null) {
          if(rs.Result.UIGuide){
            this.otaBoot = true
          }
          if (rs.Result.GpList.length > 0) {
            let _arry = []
            rs.Result.GpList.forEach((item) => {
              item.isEditor = false

              if (this.$store.state.isProfessional || !ProfessionalOnlyGpName.includes(item.GpName)) {
                _arry.push(item)
              }
            })

            this.setIsConfiguration(rs.Result.GpList)
            this.param = _arry
            this.olddata = JSON.parse(JSON.stringify(rs.Result.GpList)) // 直接复制会导致绑定到数据模型
          }
        }
      }
    },
    /* 获得设备参数
     * _type : 类型
     */
    doFindConfigAbility (_type) {
      let para = { vDeviceId: this.model.VDeviceId }
      // this.isConfiguration = false
      if (_type == 1) {
        FindConfigAbility(para, this.functionDoFindConfigAbilityTolddata)
      } else {
        FindConfigAbility(para, this.functionDoFindConfigAbility)
      }

      para = null
    },
    /* 
     * 未使用
     */
    addList (item) {
      this.GpDetails = item
    },
    functionDoRestart (rs) {
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        alertsuccess(this, rs.StatusCode)
        this.$emit('dosuccess', 4)
      } else {
        alerterror(this, rs.StatusCode)
      }
    },
    /* 点击重启按钮
     */
    doRestart () {
      // 重启
      let para = { vDeviceId: this.model.VDeviceId }
      Restart(para, this.functionDoRestart)
      para = null
    },
    /* 点击恢复出厂设置按钮 接口返回数据处理
     * rs:返回数据包
     */
    functionDoReset (rs) {
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        alertsuccess(this, rs.StatusCode)
        this.$emit('dosuccess', 3)
      } else {
        alerterror(this, rs.StatusCode)
      }
    },
    callCurtainList(item) {
      try {
        (item.Values || []).forEach(item => {
          item.DefaultValue = item.EnumValue[0].Value;
        })
      } catch (error) {
        console.log('callCurtainList', error);
      }

      this.doCallAction(item);
      // console.log('callCurtainList', item);
    },
    /* 恢复出厂设置
     */
    doReset () {
      let para = { vDeviceId: this.model.VDeviceId }
      Reset(para, this.functionDoReset)
      para = null
    },
    /* 点击删除按钮 接口返回数据处理
     * rs:返回数据包
     */
    functionDoDelete (rs) {
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        alertsuccess(this, rs.StatusCode)
        this.$emit('deletedevice', this.model)
      } else {
        alerterror(this, rs.StatusCode)
      }
    },
    /* 删除设备
     */
    //天幕解绑的时候，删除本地存储的该设备的倍速和循环
  // 删除指定设备的倍速和循环信息
    removeDevicePlaySpeedAndLoop(deviceId) {
      try {
        let existingData = getLocalStoragItem("tianmuPlaySpeedAndLoop");
        if (!existingData) return;

        existingData = JSON.parse(existingData);

        if (existingData[deviceId]) {
          delete existingData[deviceId]; // 删除指定设备
          setLocalStoragItem("tianmuPlaySpeedAndLoop", JSON.stringify(existingData));
          console.log(`已删除设备 ${deviceId} 的播放速度和循环信息`);
        }
      } catch (error) {
        console.error("删除播放速度和循环信息失败", error);
      }
    },


    doDelete () {
      this.removeDevicePlaySpeedAndLoop(this.model.VDeviceId)
      // 删除设备
      let para = { vDeviceId: this.model.VDeviceId }
      Delete(para, this.functionDoDelete)
      para = null
    },

    deleteTip(title) {
      // 获取国际化翻译字符串
      let param = this.$t('deviceMsg.secondDeleteConfirm')

      // 检查字符串中是否包含 '#' 字符
      if (param.indexOf('#') >= 0) {
        // 将字符串按 '#' 分割成数组
        param = param.split('#');

        // 如果分割后的数组长度为 3
        if (param.length === 3) {
          param = param[0]  + title + param[2];
          return param;
        }
      }
    },
    /* 点击操作按钮的处理
     * _type： 类型
     */
    pannelControl (_type) {
      // 1：替换 2：删除 3：恢复出厂设置 4：重启 5: 校准  6 解绑
      let title = ''
      if (_type == 2) {
        title = this.$t('deviceMsg.deletedeviceinfor') +  (this.model.ChildCategoryType === 1 ? '<br/>' + this.$t('scene.gatewayDeleTip') : '')
        if(this.showTianMu){
          title = this.getDelTianMuTitle(_type)
        }
      } else if (_type == 3) {
        title = this.$t('deviceMsg.resetdeviceinfor')
      } else if (_type == 4) {
        title = this.$t('deviceMsg.restartdeviceinfor')
        // } else if (_type == 5) {
        // title = this.$t('deviceMsg.calibratedeviceinfor');
      } else if(_type === 6 || _type === 7) {
        title = this.getDelTianMuTitle(_type)
      } else {
        title = this.$t('deviceMsg.replacedeviceinfor')
      }

      this.$confirm(title, this.$t('deviceMsg.prompt'), {
        confirmButtonText: this.$t('deviceMsg.save'),
        cancelButtonText: this.$t('deviceMsg.cancle'),
        type: 'warning',
        dangerouslyUseHTMLString: true
      })
        .then(() => {
          if (_type == 4) {
            this.doRestart()
          } else if (_type == 3) {
            this.doReset()
          } else if (_type == 2 || _type === 6) {
              if (this.model.ChildCategoryType === ChildCategoryTypeEum.gateWay || this.model.ChildCategoryType === ChildCategoryTypeEum.adapter ) {
                this.$confirm(this.deleteTip(this.model.DeviceName), {
                  confirmButtonText: this.$t('deviceMsg.save'),
                  cancelButtonText: this.$t('deviceMsg.cancle'),
                  type: 'warning'
              }).then(() => {
                this.doDelete()
              }).catch(() => {
                // 用户取消删除操作
                })
              } else {
                this.doDelete()
              }
            // } else if (_type == 5) {
            // this.calibrateShow(true);
          } else if(_type === 7) {
            this.reBuild()
          } else {
          }
        })
        .catch(() => { })
      title = null
    },
    hasUIPrecision(e){
      try {
        if(e.UI.Precision){
          e.DefaultValue = e.DefaultValue.toFixed(1)
        }
      } catch (error) {
      }
    },
    /* 配置参数格式化
     */
    paramBut (item, index, _GpNo) {
      this.activeParam = index
      this.GpNo = _GpNo
      let _item = []
      this.defaultcheck = []
      let _keyid = 0
      item.GpDetails.forEach((model, index) => {
        if (model?.ShowCondition&&model.ShowCondition.KeyId == 0) {
          model.isDisplay = true
        } else {
          let _temarry
          const _tem = item.GpDetails.find(function (n) {
            if (n.DefaultValue?.toString().indexOf(',') != -1) {
              _temarry = n.DefaultValue.split(',')
              return (
                n.KeyId == model?.ShowCondition?.KeyId &&
                _temarry.indexOf(model.ShowCondition.KeyValue.toString()) != -1
              )
            } else {
              return (
                n.KeyId == model?.ShowCondition?.KeyId &&
                n.DefaultValue == model.ShowCondition.KeyValue
              )
            }
          })
          if (typeof _tem === 'undefined') {
            model.isDisplay = false
          } else {
            model.isDisplay = true
          }

          _temarry = null
        }
        if (model.ValueType == 'MultipleEnum') {
          debugger
        _keyid = model.KeyId
        const _arryDefault = model.DefaultValue.split(',')
        model.EnumValue.forEach((_tem) => {
          if (_arryDefault.indexOf(_tem.Value.toString()) != -1) {
            this.defaultcheck.push(_tem.Value)
          } else {
            this.defaultcheck.push(-1)
          }
        })
      }

      if (model.ValueType == 'UIControl_MultipleBitEnum_ReverseSwitch') {

        _keyid = model.KeyId

        /* 位运算 */
        model.EnumValue.forEach((_tem) => {
          if (model.DefaultValue&_tem.Value) {
            this.defaultcheck.push(_tem.Value)
          } else {
            this.defaultcheck.push(0)
          }

        })
      }

      if (model.ValueType === 'Input' || model.ValueType === 'FloatInput') {
        try {
          if (model.UI?.Precision) {
            const p = model.UI.Precision;
            model.DefaultValue = model.DefaultValue * p;
            model.Max = model.Max * p;
            model.Min = model.Min * p;
          }
        } catch (error) {
        }
      }

      /* 通过等于‘UIControl_Bright’判断 255转100亮度  且没有处理过*/
      if(model.ValueType === 'UIControl_Bright' && !model.handleChecked){
        model.DefaultValue = this.rhythmlLightInforValue(model.DefaultValue)
        model.Min = this.rhythmlLightInforValue(model.Min)
        model.Max = this.rhythmlLightInforValue(model.Max)
        model.handleChecked = true //增加字段表示已经转过
      }

        _item.push(model)
      })

      item.GpDetails = _item.slice();

      this.GpDetails = item
      this.isShuanglu = this.GpDetails?.GpDetails?.some(item => item.ValueType === 'UIControl_MultiIChildDevice')
      this.TT = _item.slice();
      _item = null
    },

    /**
     * 特别处理wifi保存
     */
    handleWifiSave() {
      const abilityWifiRef = this.$refs.abilityWifi;
      const isCanSubmit = abilityWifiRef.validate();

      if (isCanSubmit.status === false) {
        this.$message({
          type: 'warning',
          message: isCanSubmit.msg
        });
        return;
      }

      const reqData = abilityWifiRef.getFormData();

      console.log('reqData', reqData);
      this.doSetConfigs(reqData)
    },

    handleSaveConfig(){
      this.handleSave()
    },

    //低功耗 保存配置提醒
    handleSaveUpgradeType(){
      if(this.LEGattValue){
        this.$refs.LEGattConfig?.doGetUIGuideDataList()
      }else{
        this.handleSave()
      }
    },

    handleElfSave() {
      this.isOppleElfNoticeDialogVisible = true;
    },

    hideElfDialog() {
      this.isOppleElfNoticeDialogVisible = false;
    },

    /* 是否对配置参数进行过修改 如果修改过 则按钮可提交 反之灰掉
     */
    handleSave () {
      const form = this.$refs.abilityUiFrom;

      // 双路控制器的检测
      form?.onSave();

      const abilityWifiRef = this.$refs.abilityWifi;
      let abilityPanel
      let abilityNeighborGroup
      try {
        if(this.$refs.abilityPanel[0]){
          abilityPanel = this.$refs.abilityPanel[0]
        }
      } catch (error) {

      }
      try {
        if(this.$refs.abilityNeighborGroup[0]){
          abilityNeighborGroup = this.$refs.abilityNeighborGroup[0]
        }
      } catch (error) {

      }

      this.hideElfDialog();

      // 走的wifi配置 完全不同处理逻辑
      if (abilityWifiRef) {
        this.handleWifiSave()
        return
      }

      const valiAbilityComForm = form.validateForm();
      const abilityComDataList = form.getFormData();


      // 校验失败
      if (valiAbilityComForm.status === false) {
        this.$message({
          type: "warning",
          message: valiAbilityComForm.msg
        });

        return;
      }

      // if (this.GpDetails.isEditor) {
      let _tempArry = []
      let allitem = 0
      this.GpDetails.GpDetails.forEach((item) => {
        if ([
          'UIControl_ImageEnumType',
          'UIControl_TimeRangeType',
          'UIControl_ImageIconEnumType',
          'Input',
          'FloatInput',
          'UIControl_TimePicker',
          'UIControl_ResetTime',
          'UIControl_MultiIChildDevice',
          'UIControl_Slider'
        ].includes(item.ValueType)) return;
        if (item?.isDisplay && item?.IsShow) {
          if (!item.Readonly) {
            if (item.ValueType !== 'UIControl_MultipleBitEnum_ReverseSwitch') {
              if(item.ValueType === 'UIControl_Bright'){
              _tempArry.push({
                Key: item.KeyId,
                Values: this.rhythmlLightInforValueSubmit(item.DefaultValue).toString().split(',')
              })
            } else if(item.ValueType === 'UIControl_NeighborGroupInput'){
              _tempArry.push({
                Key: item.KeyId,
                Values: abilityNeighborGroup.neighborPostValue.toString().split(',')
              })
            } else if(item.ValueType === 'UIControl_PanelLinkage'){
              _tempArry.push({
                Key: item.KeyId,
                Values: abilityPanel.postDeviceMacData.toString().split(',')
              })
            }else{
              let hasUIPrecision = false
              try {
                if(item.UI.Precision){
                  hasUIPrecision = true
                }
              } catch (error) {

              }
              if(hasUIPrecision){
                const  _Precision = item.UI.Precision.split('.')[1].split('').length * 10

                _tempArry.push({
                  Key: item.KeyId,
                  Values: (item.DefaultValue*_Precision).toString().split(',')
                })
              }else{
                _tempArry.push({
                  Key: item.KeyId,
                  Values: item.DefaultValue.toString().split(',')
                })
              }

            }
            } else {
              allitem = 0
              item.DefaultValue.toString().split(',').forEach(item => {
                allitem = allitem + Number(item)
              })
              _tempArry.push({
                Key: item.KeyId,
                Values: allitem.toString().split(',')
              })

            }
          }
        }
      });

      const ConfigItemsAll = _tempArry.concat(abilityComDataList);
      const lastData = ((this.olddata || []).find(item => item.GpNo === this.GpNo) || {}).GpDetails || [];
      const ConfigItemsHasChange = [];

      ConfigItemsAll.forEach(configItem => {
        const lastItem = lastData.find(data => data.KeyId === configItem.Key) || {}
        const lastValue = lastItem.DefaultValue.toString().split(',');
        const currentValue = configItem.Values;
        // ResultCode
        // 数组数据不一致。
        // 判定为修改过
        const hasChange = !areArraysEqualIgnoreOrder(lastValue, currentValue);

        // 失败状态或者配置中修改过的才进去
        // 防止失败状态无法下发
        if (hasChange || lastItem.ResultCode === 2 || lastItem.ResultCode === 0) {
          ConfigItemsHasChange.push({
            Key: configItem.Key,
            Values: configItem.Values
          })
        };
      });

      let para = {
        VDeviceId: this.model.VDeviceId,
        GpNo: this.GpNo,
        ConfigItems: ConfigItemsHasChange
      }

      if (ConfigItemsHasChange.length === 0) {
        return;
      }
      // console.log('para', para, this.olddata)

      // debugger
      // return

      this.doSetConfigs(para);

      form.getFormData();
      this.GpDetails.isEditor = false

      // }
    },
    /* 设置设备参数 接口返回数据处理
     * rs： 接口返回回来的数据包
     */
    functionDoSetConfigs (rs) {
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        // alertsuccess(this, rs.StatusCode)
        this.doFindConfigAbility(1)

        // 查询更改源数据
      } else {
        alerterror(this, rs.StatusCode)
      }
    },
    /* 设置设备参数
     * para： 要提交的数据
     */
    doSetConfigs (para) {
      SetConfigs(para, this.functionDoSetConfigs)
    },
    /* 显示隐藏设备参数的下拉 例如协议类型
     */
    start () {
      this.rotate = !this.rotate
    },
    /* 未使用
     */
    dele () {
      this.$store.dispatch('deleButton')
    },
    async reBuild() {
      const res = await findByPlanId({
        planId: this.PlanId
      });

      let tianmuProxy = new TianmuProxy(res.Result)

      this.$router.push({
        name: 'addCustomTianm',
        params: {
          shapeType: 2,
          checkDeviceList: this.childDeviceList,
          from: 'edit',
          GpNo: this.model.Gpno,
          deviceText: this.model.DeviceName,
          CustomGroups: [],
          tianmuVDeviceId: this.model.VDeviceId,
          channelCount: tianmuProxy.channelCount,
          planId: this.PlanId,
          // tianmuPoints: this.tianmuProxy.getTianmuScencePoint(this.tianmuControlInfo)
        }
      });
    },
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/css/action.scss';
.ip_dropdown {
  overflow: hidden;
}
.newset {
  padding: 3px 16px;
  border-radius: 3px;
  border: solid 1px #c6c6c6;
  background: transparent;
  color: #959393;
}
.gray {
  color: #cacaca !important;
  background: #e5e5e5 !important;
}
.blue {
  color: #fff !important;
  background: #0046aa !important;
}

.blue:hover {
  color: #fff !important;
  background: #0046aa !important;
}

.deviceMsg .border_cont .base_msg li {
  span {
    height: 50px !important;
    line-height: 16px !important;
    // -webkit-line-clamp: none;
    // -webkit-box-orient: none;
  }
  span:first-child {
    width: 40% !important;
    text-align: right !important;
  }
  span:last-child {
    width: 60% !important;
    text-align: left !important;
  }
}
// .scence_box {
//   overflow: hidden;
// }

.scence_box::after {
  content: '';
  overflow: hidden;
}

.hcl-box {
  float: left;
  display: flex;
  justify-content: center;
  width: 100%;
}
.hcl-tips {
  display: flex;
  justify-content: center;
  color: #666666;
  font-size: 12px;
  line-height: 22px;
  div:nth-child(2) {
    max-width: 600px;
    margin-left: 30px;
  }
  .el-icon-info {
    color: #2589ff;
  }
}

/* 设备详情组件	 */
.scence_line i {
  color: #619df1;
  font-size: 28px;
}
.warm_button {
  width: max-content;
  /*width: 73px;*/
  height: 32px;
  border-radius: 3px;
  border: solid 1px #619df1;
  color: #619df1;
  background: #fff;
  line-height: 32px;

  &:hover {
    background: #619df1;
    color: #fff;
    i {
      color: #fff;
    }
  }
  i {
    font-size: 14px;
    margin-top: 5px;
  }
}
.statr_button {
  width: 85px;
  font-size: 12px;
  i {
    font-size: 20px;
    margin-right: -8px;
    float: left;
    margin-left: 16px;
    font-weight: normal;
    margin-top: 5px;
  }
}

.scene_bolder {
  background-color: #fefefe;
  border: solid 1px #e0e3e6;
  padding: 41px 5px 40px 5px;

  .scence_allset_title {
    font-size: 16px;
    color: #2a79f0;
  }
  .line_one {
    margin-top: 54px;
  }
  .scence_line_msg {
    font-size: 14px;
    color: #111111;
    margin-bottom: 13px;
    line-height: 36px;
    .scence_span {
      display: inline-block;
    }

    .scence_div {
      display: inline-block;

      position: relative;
      .scence_img {
        height: 36px;
        vertical-align: middle;
      }
      .el-icon-edit {
        position: absolute;
        left: 100px;
        top: 11px;
      }
      .scence_name {
        width: 130px;
      }
      .scence_address {
        position: absolute;
        top: 0px;
        left: 45px;
        width: 85px;
        margin-top: 5px;
      }
    }
  }
}

.curtainList_row {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 47%;
  // margin-left: 2%;
  // position: relative;

  & > li {
    margin-right: 40px;
    cursor: pointer;
  }

  img {
    width: 40px;
    height: 40px;
  }

  p {
    text-align: center;
    line-height: 16px;
  }
}
.magin40 {
  margin-bottom: 40px;
}
.icon--96 {
  color: #619df1;
  font-size: 28px;
  font-weight: bold;
}
.icon--97 {
  color: #619df1;
  font-size: 28px;
  font-weight: bold;
}

.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter,
.slide-fade-leave-to {
  transition: translateX(10px);
  opacity: 0;
}
.activeParam_box {
  /*height: 360px;*/
  height: 100%;
}
.disable {
  pointer-events: none;
  border: 1px solid #f0ecec;
  :hover {
    background: transparent;
    color: #f0ecec;
  }
}
.curr_card {
  background: #619df1;
  color: #fff;
}
.oper_ul span i {
  font-size: 20px;
  text-align: center;
  display: block;
  line-height: 60px;
  cursor: pointer;
}
.deviceMsg {
  &_noAbility {
    display: flex;
    align-items: center;
    justify-content: center;

    &_container {
      width: 350px;
      padding: 80px 0 30px;
      text-align: center;

      img {
        width: 100%;
        margin-bottom: 18px;
      }
    }
  }

  .color-item {
    float: left;
    margin-right: 20px;
  }
  .border_title {
    text-indent: 10px;
    font-size: 16px;
    color: #111111;
    position: relative;

    &:after {
      width: 2px;
      background-color: $color5;
      bottom: 0;
      content: '';
      position: absolute;
      left: 0;
      height: 16px;
    }
  }
  .border_cont {
    display: flex;
    border: solid 1px #e0e3e6;
    .base_msg {
      width: 100%;
      height: auto;
      overflow: hidden;
      font-size: 14px;
      color: #303030;
      margin: 20px 0;
      li {
        font-weight: 500;
        color: rgba(30, 30, 30, 1);
        text-indent: 40px !important;
        height: auto;
        margin: 5px 0;
      }
    }
    .heightMore {
      height: 180px;
    }
  }
  .border_none {
    margin-bottom: 80px;
    border: solid 1px transparent;
  }
  .warm_button_select {
    background: #619df1;
    color: #fff;
  }
  .svg_calibrate {
    height: 100%;
    background-position: 50%;
    background-image: url('../../assets/img/svg/jiaozhun_1.svg');
    background-repeat: no-repeat;
    &:hover {
      background-color: #619df1;
      background-image: url('../../assets/img/svg/jiaozhun_h.svg');
    }
  }
  .curr_card .svg_calibrate {
    background-image: url('../../assets/img/svg/jiaozhun_h.svg');
  }
  .disable .svg_calibrate {
    opacity: 0.1;
    background-image: url('../../assets/img/svg/jiaozhun.svg');
  }
  li.calibrateLUX {
    b {
      display: inline-block;
      min-width: 50px;
      text-align: center;
      text-indent: initial;
      margin: 0 5px;
      border-bottom: dashed 1px #303030;
    }

    input {
      font-size: 14px;
      border: none;
      border-bottom: dashed 1px #303030;
      text-align: center;
      width: 60px;
    }
  }
}
.calibrateBox {
  .calibrateBoxInner {
    position: relative;
    background: white;
    padding: 0 20px 10px 20px;
    li {
      width: 100%;
      display: flex;
      div {
        height: 100%;
        margin: 1%;
      }
    }
    li.calibrateHead {
      span {
        width: 50%;
        float: left;
      }
    }
    li.calibrateHead,
    li.calibrateResultHead,
    li.calibrateCurNewHead {
      font-size: 13px;
      font-weight: 500;
      color: rgba(48, 48, 48, 1);
      height: 20px;
      div {
        float: left;
        width: calc(50% - 40px);
        height: 100%;
      }
    }
    li.calibrateResultBody,
    li.calibrateCurNewBody {
      position: relative;
      font-size: 16px;
      font-weight: 500;
      color: rgba(48, 48, 48, 1);
      margin-bottom: 15px;
      height: 35px;
      div {
        float: left;
        width: calc(50% - 40px);
        background: rgba(239, 242, 247, 1);
        /*
        border:1px solid rgba(212,216,223,1);
        */
        border-radius: 3px;
        input,
        .calibrate_input {
          border: none !important;
          background: transparent;
          position: relative;
          height: 40px;
          width: calc(100% - 55px);
          font-size: 16px;
          font-weight: 500;
          color: #303030;
          padding: 0 5px;
          margin: 0;
        }
        input::-webkit-input-placeholder {
          /* WebKit browsers */
          color: rgba(153, 153, 153, 1);
          font-size: 13px;
          line-height: 24px;
        }
        input::-moz-placeholder {
          /* Mozilla Firefox 4 to 18 */
          color: rgba(153, 153, 153, 1);
          font-size: 13px;
          line-height: 24px;
        }
        input::-moz-placeholder {
          /* Mozilla Firefox 19+ */
          color: rgba(153, 153, 153, 1);
          font-size: 13px;
          line-height: 24px;
        }
        input::-ms-input-placeholder {
          /* Internet Explorer 10+ */
          color: rgba(153, 153, 153, 1);
          font-size: 13px;
          line-height: 24px;
        }
        .calibrate_input input {
          font-size: 160px;
        }
        span {
          color: #abaaaa;
          /*
          color:rgba(48,48,48,1);
          */
          line-height: 40px;
          margin: 0 5px;
        }
        :nth-child(2) {
          float: right;
        }
      }
      :nth-child(3) {
        float: left;
        width: 30px;
        border: none;
        line-height: 40px;
        background: none;
        text-align: center;
        span {
          color: red;
        }
        button {
          width: 16px;
          height: 16px;
          height: auto;
          margin: 0;
          padding: 0;
          border-color: #cccccc;
          border-radius: 50px;
          background: #cccccc;
          color: white;
          font-size: 12px;
        }
        button:hover {
          background: rgb(0, 70, 170);
          color: rgb(255, 255, 255);
        }
      }
    }
    li.calibrateCurNewBody {
      :nth-child(2) {
        background: none;
      }
    }
    li.calibrateResultHead div {
      width: 100%;
    }
    li.calibrateHead {
      margin-bottom: 15px;
      div {
        font-size: 18px;
        font-weight: 500;
        color: rgba(48, 48, 48, 1);
        button {
          position: absolute;
          right: 0px;
          width: 81px;
          height: 26px;
          font-size: 14px;
          background-color: #fff;
        }
      }
    }
  }
  button {
    width: 140px;
    height: 40px;
    border: 1px solid rgba(0, 70, 170, 1);
    border-radius: 3px;
    font-size: 14px;
    font-weight: 500;
    color: rgba(0, 70, 170, 1);
    margin: 0 35px;
    background-color: #fff;
  }
}
.ota_span {
  width: 16% !important;
  text-align: right;
  display: inline-block;
}

.deviceMsg .border_cont .base_msg li span:first-child {
  width: max-content !important;
  margin-left: 20px !important;
}
.deviceMsg .ota_span {
  width: auto !important;
  margin-left: 0px !important;
}
.temperaturePlane {
  width: 230px;
  height: 230px;
  background-repeat: no-repeat;
  background-size: contain;
  background-image: url('../../assets/img/ota/temperaturePlane.png');
}
.scence_ctr_span {
  word-break: break-word !important;
  width: 96px !important;
}

.ota_line {
  .gray {
    color: #cacaca !important;
    background: #e5e5e5 !important;
  }
  .blue {
    color: #fff !important;
    background: #0046aa !important;
  }

  .blue:hover {
    color: #fff !important;
    background: #0046aa !important;
  }
}
// ::v-deep .el-input__inner{
//   border: solid 1px #bdc5d3 !important;
//   padding:0px 10px !important;
// }
// ::v-deep .el-input{
//   border-bottom: none !important;
// }
.full-row {
  clear: both;
  width: 100%;
  margin-left: 2%;
}
.force_full_row {
  clear: both;
  width: 100% !important;
  margin-left: 2%;
}
.force_device_div {
  width: 47% !important;
}
.force_device .force_full_row {
  clear: both;
  width: 100% !important;
  margin-left: 2%;
}
.force_device_div {
  width: 47% !important;
}
.force_device .region-item-style {
  max-width: 200px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.el-message {
  z-index: 9999;
}
.DUV_slider {
  margin-left: 0px !important;
}
.DUV_slider {
  margin-left: 0px !important;
}
.new_device_div {
  float: none;
}
.scence_ctr {
  margin: 5px 0px;
}
.singleOta {
  font-size: 12px;
  width: max-content;
  border-radius: 5px;
  border: 1px solid rgb(233, 236, 244);
  margin-right: 15px;
  padding-bottom: 5px;
  text-align: left;
  line-height: 25px;
  .header {
    line-height: 50px;
    padding: 0px 10px;
    border-bottom: 1px solid rgb(233, 236, 244);
    margin-bottom: 5px;
    text-align: center;
    background: rgb(248, 248, 248);
  }
  .ota_line {
    padding: 0px 10px;
  }
}
.ota_left {
  background: rgb(241, 244, 251);
  line-height: 50px;
  padding: 0px 10px;
}
.radio-group {
  display: flex;
  justify-content: center;
}
.ota_set_tianmu {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  position: relative;
}
.oneUpLevel {
  position: absolute;
  right: 0px;
  top: -20px;
  color: #2481ea;
  cursor: pointer;
}
.recommendedY {
  position: absolute;
  right: 45px;
  bottom: -24px;
  font-size: 13px;
}
.device_msg_dropdown.ip_dropdown{
  width: unset;
  min-width: 216px!important;
}

</style>
<style>
.my-label {
  background: #ebf5ff;
}
.duv_add .el-slider__runway {
  background: linear-gradient(to right, #ef8a7f, #ffffff, #d8e2a6);
}
.duv_add .el-slider__bar {
  background-color: transparent;
}
.custom-tag {
  margin: 5px;
  cursor: pointer;
}
</style>
